var cartNoteTyping;

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

/**
 * Racines des totaux à synchroniser : résumé page panier ([data-cart-page-summary]) et/ou drawer,
 * pour ne pas mélanger les mises à jour avec d’autres blocs du DOM.
 */
function getCartSummaryRoots() {
  var $roots = $();
  if ($("[data-cart-page-summary]").length) {
    $roots = $roots.add($("[data-cart-page-summary]"));
  }
  var $drawer = $("[data-drawer-body]");
  if ($drawer.length && $drawer.find("[data-cart-total-price]").length) {
    $roots = $roots.add($drawer);
  }
  if (!$roots.length) {
    $roots = $("body");
  }
  return $roots;
}

/** Tous les [data-cart-total-price] dans les blocs récap panier (page + drawer). */
function getCartTotalPriceElements() {
  return getCartSummaryRoots().find("[data-cart-total-price]");
}

/**
 * Met à jour le prix barré (data-cart-original-total-strike) et l’éventuelle ligne legacy (data-cart-original-price).
 */
function syncCartOriginalTotalDisplay(cart, fmt) {
  if (!cart || typeof Shopify === "undefined" || !Shopify.formatMoney) return;
  var moneyFmt = fmt || (typeof moneyFormat !== "undefined" ? moneyFormat : "");
  getCartSummaryRoots().each(function () {
    var $root = $(this);
    $root.find("[data-cart-original-total-strike]").each(function () {
      var $el = $(this);
      if (cart.original_total_price > cart.total_price) {
        $el
          .text(Shopify.formatMoney(cart.original_total_price, moneyFmt))
          .removeClass("hidden")
          .show();
      } else {
        $el.text("").addClass("hidden").hide();
      }
    });
    var $legacy = $root.find("[data-cart-original-price]");
    if ($legacy.length) {
      $legacy.text(Shopify.formatMoney(cart.original_total_price, moneyFmt));
      $legacy.each(function () {
        var $originalLi = $(this).closest("[data-cart-original]");
        if ($originalLi.length) {
          if (cart.original_total_price > cart.total_price) {
            $originalLi.removeClass("hidden");
          } else {
            $originalLi.addClass("hidden");
          }
        }
      });
    }
  });
}

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
let convertShippingAmount = 0;
function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

// Variable pour éviter les appels multiples
let isUpdatingTiers = false;
let lastCartPrice = 0;

// Fonction pour capitaliser le premier mot d'un texte
function capitalizeFirstWord(text) {
  try {
    if (!text || typeof text !== 'string' || text.trim() === '') {
      return text || '';
    }
    const trimmed = text.trim();
    if (trimmed.length === 0) {
      return '';
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  } catch (e) {
    // En cas d'erreur, retourner le texte original
    return text || '';
  }
}

function freeShippingBar(cart) {
  // Vérifier si la fonctionnalité est activée
  // enable_shipping est défini dans theme-scripts.liquid
  if (typeof enable_shipping !== 'undefined' && !enable_shipping) {
    let shippingBarContainer = $("[data-free-shipping-container]");
    if (shippingBarContainer.length > 0) {
      shippingBarContainer.addClass("hidden");
    }
    return false;
  }
  
  // Ne plus vérifier countryAvailable, utiliser directement les paliers
  let shippingBarContainer = $("[data-free-shipping-container]");
  if (shippingBarContainer.length > 0) {
    // Toujours afficher la progress bar si le panier n'est pas vide
    if (cart.item_count == 0) {
      shippingBarContainer.addClass("hidden");
      return false;
    }
    
    // Toujours afficher la progress bar si le panier contient des articles
    // Ne pas utiliser removeClass si déjà visible pour éviter l'effet de flash
    if (shippingBarContainer.hasClass("hidden")) {
      shippingBarContainer.removeClass("hidden");
    }
    
    // Calculer le prix du panier en excluant les produits spécifiés
    // Combiner les exclusions globales et spécifiques par palier
    let allExcludedProductIds = [];
    
    // Récupérer les produits exclus depuis le DOM (data attribute) pour s'assurer qu'ils sont à jour après un changement de marché
    // Cette méthode est plus fiable que d'utiliser uniquement la variable JavaScript globale
    const shippingBarContainerForExcluded = $("[data-free-shipping-container]");
    if (shippingBarContainerForExcluded.length > 0) {
      const excludedProductsAttr = shippingBarContainerForExcluded.attr('data-excluded-products-from-tiers');
      if (excludedProductsAttr && excludedProductsAttr.trim() !== '') {
        const excludedIds = excludedProductsAttr.split(',').map(function(id) {
          return parseInt(id.trim());
        }).filter(function(id) {
          return !isNaN(id) && id > 0;
        });
        allExcludedProductIds = allExcludedProductIds.concat(excludedIds);
      }
    }
    
    // Fallback: Ajouter les produits exclus globaux depuis la variable JavaScript (pour compatibilité)
    if (allExcludedProductIds.length === 0 && typeof excludedProductsFromTiers !== 'undefined' && Array.isArray(excludedProductsFromTiers)) {
      allExcludedProductIds = allExcludedProductIds.concat(excludedProductsFromTiers);
    }
    
    // Calculer le prix en excluant les produits spécifiés
    let cartPrice = 0;
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(function(item) {
        // Vérifier si le produit est exclu (par product_id)
        let isExcluded = false;
        if (allExcludedProductIds.length > 0) {
          isExcluded = allExcludedProductIds.indexOf(item.product_id) !== -1;
        }
        
        // Si le produit n'est pas exclu, l'ajouter au calcul
        if (!isExcluded) {
          cartPrice += item.final_line_price;
        }
      });
    } else {
      // Fallback sur total_price si pas d'items
      cartPrice = cart.total_price;
    }
    
    // Éviter les appels multiples si le prix n'a pas changé significativement
    // Mais ne pas bloquer si on vient de la page panier (isUpdatingTiers peut être false)
    // Ne pas bloquer non plus si on vient de retirer un produit cadeau (pour vérifier les conditions)
    if (isUpdatingTiers && Math.abs(cartPrice - lastCartPrice) < 100 && !isRemovingGiftProduct) {
      return;
    }
    
    isUpdatingTiers = true;
    lastCartPrice = cartPrice;
    
    // Définir les paliers avec les nouveaux settings
    const tiers = [];
    
    // Vérifier que les variables tier sont définies
    if (typeof tier1Enabled === 'undefined') {
      tier1Enabled = false;
    }
    if (typeof tier2Enabled === 'undefined') {
      tier2Enabled = false;
    }
    if (typeof tier3Enabled === 'undefined') {
      tier3Enabled = false;
    }
    if (typeof tier1Amount === 'undefined') {
      tier1Amount = 0;
    }
    if (typeof tier2Amount === 'undefined') {
      tier2Amount = 0;
    }
    if (typeof tier3Amount === 'undefined') {
      tier3Amount = 0;
    }
    
    // Palier 1 - Type configurable (shipping, gift, ou discount)
    let tier1FinalAmount = tier1Amount || 0;
    if (tier1Enabled && tier1Amount > 0) {
      tiers.push({
        id: 1,
        amount: tier1Amount,
        iconImage: tier1IconImage,
        text: tier1Text,
        successText: tier1SuccessText,
        rewardText: (tier1RewardText && String(tier1RewardText).trim() !== '') ? String(tier1RewardText) : null,
        productId: tier1ProductId > 0 ? tier1ProductId : null,
        productName: typeof tier1ProductName !== 'undefined' ? String(tier1ProductName || '') : '',
        productPrice: typeof tier1ProductPrice !== 'undefined' ? String(tier1ProductPrice || '') : '',
        enabled: true
      });
      tier1FinalAmount = tier1Amount;
    }
    
    // Palier 2 - Montant basé sur palier 1 si non défini
    let tier2FinalAmount = tier2Amount || 0;
    if (tier2Enabled) {
      // Si montant non défini, calculer automatiquement basé sur palier 1
      if (tier2Amount <= 0 && tier1FinalAmount > 0) {
        // Par défaut, palier 2 = palier 1 * 1.5 (ou autre logique)
        tier2FinalAmount = Math.round(tier1FinalAmount * 1.5);
      }
      if (tier2FinalAmount > 0) {
        tiers.push({
          id: 2,
          amount: tier2FinalAmount,
          iconImage: tier2IconImage,
          text: tier2Text,
          successText: tier2SuccessText,
          rewardText: (tier2RewardText && String(tier2RewardText).trim() !== '') ? String(tier2RewardText) : null,
          productId: tier2ProductId > 0 ? tier2ProductId : null,
          productName: typeof tier2ProductName !== 'undefined' ? String(tier2ProductName || '') : '',
          productPrice: typeof tier2ProductPrice !== 'undefined' ? String(tier2ProductPrice || '') : '',
          enabled: true
        });
      }
    }
    
    // Palier 3 - Montant basé sur palier 1 si non défini
    let tier3FinalAmount = tier3Amount || 0;
    if (tier3Enabled) {
      // Si montant non défini, calculer automatiquement basé sur palier 1
      if (tier3Amount <= 0 && tier1FinalAmount > 0) {
        // Par défaut, palier 3 = palier 1 * 2 (ou autre logique)
        tier3FinalAmount = Math.round(tier1FinalAmount * 2);
      }
      if (tier3FinalAmount > 0) {
        tiers.push({
          id: 3,
          amount: tier3FinalAmount,
          iconImage: tier3IconImage,
          text: tier3Text,
          successText: tier3SuccessText,
          rewardText: (tier3RewardText && String(tier3RewardText).trim() !== '') ? String(tier3RewardText) : null,
          productId: tier3ProductId > 0 ? tier3ProductId : null,
          productName: typeof tier3ProductName !== 'undefined' ? String(tier3ProductName || '') : '',
          productPrice: typeof tier3ProductPrice !== 'undefined' ? String(tier3ProductPrice || '') : '',
          enabled: true
        });
      }
    }
    
    // Trier les paliers par montant croissant (ordre naturel 1, 2, 3)
    tiers.sort((a, b) => a.amount - b.amount);
    
    // Trouver le palier actuel et le prochain
    let currentTier = null;
    let nextTier = null;
    
    for (let i = 0; i < tiers.length; i++) {
      if (cartPrice >= tiers[i].amount) {
        currentTier = tiers[i];
        if (i < tiers.length - 1) {
          nextTier = tiers[i + 1];
        }
      } else {
        nextTier = tiers[i];
        break;
      }
    }
    
    // Mettre à jour l'affichage des paliers (fonctionne avec tous les types de paliers)
    if (tiers.length > 0) {
      updateTiersDisplay(tiers, currentTier, nextTier, cartPrice);
    }
    
    // Gérer les produits cadeaux
    manageGiftProducts(tiers, cartPrice, cart);
    enforceTierGiftQuantityLimits(cart);
    updateTierGiftCartItemUi();
    
    // Gérer les produits d'ajout rapide
    manageQuickAddProducts(cart);
    
    // Réinitialiser le flag après un court délai
    setTimeout(() => {
      isUpdatingTiers = false;
    }, 500);
  }
}

// Flag pour indiquer si la détection du nombre de lignes a déjà été faite
let tierTextLineHeightChecked = false;

function updateTiersDisplay(tiers, currentTier, nextTier, cartPrice) {
  if (tiers.length === 0) {
    return;
  }
  
  // S'assurer que le container est visible (sans effet de disparition/apparition)
  const shippingBarContainer = $("[data-free-shipping-container]");
  if (shippingBarContainer.length > 0) {
    // Ne pas utiliser removeClass('hidden') pour éviter l'effet de flash
    // Le container reste visible et seule la progress-bar s'anime
    if (shippingBarContainer.hasClass('hidden')) {
      shippingBarContainer.removeClass('hidden');
      // Forcer le reflow pour que la transition fonctionne
      shippingBarContainer[0].offsetHeight;
    }
  }
  
  // Trouver le premier palier (palier 1) pour la progress bar
  const firstTier = tiers[0];
  const lastTier = tiers[tiers.length - 1];
  const allTiersReached = cartPrice >= lastTier.amount;
  
  // Trouver le palier actuel (le prochain non atteint, ou le dernier si tous sont atteints)
  let currentActiveTier = null;
  for (let i = 0; i < tiers.length; i++) {
    if (cartPrice < tiers[i].amount) {
      currentActiveTier = tiers[i];
      break;
    }
  }
  // Si tous les paliers sont atteints, utiliser le dernier
  if (!currentActiveTier) {
    currentActiveTier = lastTier;
  }
  
  // Calculer le pourcentage de la progress bar pour qu'elle atteigne réellement les icônes
  // La barre doit atteindre le premier palier quand le montant est atteint, puis le deuxième, etc.
  let progressPercentage = 0;
  
  // Trouver le segment actuel
  let currentSegmentIndex = -1;
  for (let i = 0; i < tiers.length; i++) {
    if (cartPrice < tiers[i].amount) {
      currentSegmentIndex = i;
      break;
    }
  }
  
  // Fonction helper pour calculer la position d'un palier (identique à celle utilisée pour les marqueurs)
  function getTierPosition(index, totalTiers) {
    if (totalTiers === 1) {
      // Si un seul palier, le positionner à 75% pour laisser de l'espace
      // La progress bar pourra atteindre 100% et dépasser le palier
      return 75;
    } else if (totalTiers === 2) {
      return index === 0 ? 25 : 75;
    } else if (totalTiers === 3) {
      return index === 0 ? 20 : (index === 1 ? 50 : 80);
    } else {
      const margin = 10;
      const availableWidth = 100 - (2 * margin);
      return margin + (index * availableWidth / (totalTiers - 1));
    }
  }
  
  // Si tous les paliers sont atteints
  if (currentSegmentIndex === -1) {
    // Atteindre 100% pour montrer que la progress bar est complétée
    progressPercentage = 100;
  } else {
    // On est dans un segment
    const currentTier = tiers[currentSegmentIndex];
    const previousTierAmount = currentSegmentIndex > 0 ? tiers[currentSegmentIndex - 1].amount : 0;
    
    // Position de l'icône du palier actuel
    const targetIconPosition = getTierPosition(currentSegmentIndex, tiers.length);
    
    // Position de l'icône du palier précédent (ou 0 si c'est le premier)
    let previousIconPosition = 0;
    if (currentSegmentIndex > 0) {
      previousIconPosition = getTierPosition(currentSegmentIndex - 1, tiers.length);
    }
    
    // Si un seul palier est actif, la progress bar progresse de 0% à 100%
    // Le palier est à 75%, donc quand on atteint le montant, on est à 75%
    // Mais on peut aller jusqu'à 100% pour montrer que c'est complété
    if (tiers.length === 1) {
      const segmentProgress = cartPrice;
      const segmentPercentage = Math.min(Math.max((segmentProgress / currentTier.amount) * 100, 0), 100);
      // Si le palier est atteint, on peut aller jusqu'à 100%
      if (segmentPercentage >= 100) {
        progressPercentage = 100;
      } else {
        // Sinon, on calcule proportionnellement jusqu'à 75% (position du palier)
        progressPercentage = (segmentPercentage / 100) * 75;
      }
    } else {
      // Calculer le pourcentage dans ce segment (0-100%)
      const segmentSize = currentTier.amount - previousTierAmount;
      // S'assurer que segmentSize n'est pas 0 pour éviter division par zéro
      if (segmentSize <= 0) {
        progressPercentage = previousIconPosition;
      } else {
        const segmentProgress = cartPrice - previousTierAmount;
        const segmentPercentage = Math.min(Math.max((segmentProgress / segmentSize) * 100, 0), 100);
        
        // La barre progresse de la position précédente vers la position actuelle
        const distanceToTarget = targetIconPosition - previousIconPosition;
        progressPercentage = previousIconPosition + (segmentPercentage * distanceToTarget / 100);
      }
    }
  }
  
  // Limiter entre 0 et 100% (permettre d'atteindre 100% quand tous les paliers sont atteints)
  progressPercentage = Math.max(0, Math.min(100, progressPercentage));
  
  // Mettre à jour la progress bar (toujours afficher, même sans palier shipping)
  // Utiliser une transition CSS pour une animation fluide
  if ($("[data-free-shipping-bar]").length > 0) {
    const progressBar = $("[data-free-shipping-bar]");
    // La transition CSS s'occupe de l'animation, on met juste à jour la largeur
    progressBar.css("width", progressPercentage + "%");
  }
  
  // Retourne le texte sans répétition consécutive (ex: "A A" -> "A") pour éviter que le DOM déjà dupliqué ne propage le doublon
  function ensureSingleOccurrence(text) {
    if (!text || typeof text !== 'string') return text;
    const t = text.replace(/\s+/g, ' ').trim();
    if (t.length < 2) return t;
    const parts = t.split(/\s+/);
    for (let n = 1; n < parts.length; n++) {
      const left = parts.slice(0, n).join(' ');
      const right = parts.slice(n).join(' ');
      if (left === right) return left;
    }
    return t;
  }

  // Fonction helper pour récupérer les informations du produit depuis le DOM
  function getProductInfo(productId) {
    if (!productId || productId <= 0) {
      return { name: '', price: '' };
    }

    // Un seul bloc cadeau : il peut exister 2× [data-tier-gifts-container] (page panier + drawer).
    // Sans .first(), jQuery concatène le texte de tous les h4 → "NOMNOM".
    let giftWrapper = $();
    if ($("[data-cart-wrapper]").length) {
      giftWrapper = $("[data-cart-wrapper]")
        .find("[data-tier-gifts-container]")
        .find('[data-product-id="' + productId + '"]')
        .first();
    }
    if (!giftWrapper.length && $("[data-drawer-body]").length) {
      giftWrapper = $("[data-drawer-body]")
        .find("[data-tier-gifts-container]")
        .find('[data-product-id="' + productId + '"]')
        .first();
    }
    if (!giftWrapper.length) {
      giftWrapper = $("[data-tier-gifts-container]")
        .find('[data-product-id="' + productId + '"]')
        .first();
    }
    if (giftWrapper.length === 0) {
      return { name: '', price: '' };
    }
    
    // Nom produit : attributs data en priorité, puis markup carte cadeau
    let productName = giftWrapper.attr('data-product-name') || '';
    if (!productName) {
      const productNameElement = giftWrapper.find('[data-tier-gift-product-name]').first();
      productName = productNameElement.length > 0
        ? (productNameElement.attr('data-tier-gift-product-name') || productNameElement.text().trim())
        : '';
    }
    if (!productName) {
      const titleElement = giftWrapper.find('.tier-gift-product-card a p').first();
      productName = titleElement.length > 0 ? titleElement.text().trim() : '';
    }
    productName = ensureSingleOccurrence(productName);
    
    // Récupérer le prix du produit (prix barré = prix catalogue)
    let productPrice = giftWrapper.attr('data-product-price') || '';
    if (!productPrice) {
      const priceElement = giftWrapper.find('.tier-gift-product-card .line-through').first();
      if (priceElement.length > 0) {
        productPrice = priceElement.text().trim();
      } else {
        const fallbackPriceElement = giftWrapper.find('.tier-gift-product-card .font-extrabold').first();
        if (fallbackPriceElement.length > 0) {
          productPrice = fallbackPriceElement.text().trim();
        }
      }
    }
    
    return { name: productName, price: productPrice };
  }
  
  // Fonction helper pour remplacer les variables dans un texte
  function replaceTierVariables(text, tier) {
    if (!text || String(text).trim() === '') {
      return text;
    }
    
    let result = String(text);
    
    // Remplacer ||reward||
    if (tier.rewardText !== null && tier.rewardText !== undefined && String(tier.rewardText).trim() !== '') {
      result = result.replace(/\|\|reward\|\|/g, String(tier.rewardText));
    }
    
    // Remplacer ||product|| et ||price|| si le palier a un produit associé
    if (tier.productId && tier.productId > 0) {
      const productInfo = {
        name: tier.productName || '',
        price: tier.productPrice || ''
      };
      if (!productInfo.name || !productInfo.price) {
        const domProductInfo = getProductInfo(tier.productId);
        if (!productInfo.name) {
          productInfo.name = domProductInfo.name;
        }
        if (!productInfo.price) {
          productInfo.price = domProductInfo.price;
        }
      }
      if (productInfo.name) {
        result = result.replace(/\|\|product\|\|/g, productInfo.name);
      }
      if (productInfo.price) {
        result = result.replace(/\|\|price\|\|/g, productInfo.price);
      }
    }
    
    return result;
  }
  
  // Mettre à jour le message unique au-dessus de la progress bar
  // Ne cibler qu'un seul élément (le premier dans le wrapper panier) pour éviter duplication à chaque rechargement AJAX
  const allMessageElements = $("[data-free-shipping-text]");
  const messageElement = $("[data-cart-wrapper]").find("[data-free-shipping-text]").length > 0
    ? $("[data-cart-wrapper]").find("[data-free-shipping-text]").first()
    : allMessageElements.first();
  if (messageElement.length > 0) {
    let textToSet = '';
    if (allTiersReached) {
      // Tous les paliers sont atteints, afficher le success message du dernier avec remplacement de ||reward||, ||product|| et ||price||
      textToSet = replaceTierVariables(lastTier.successText || '', lastTier);
    } else {
      // Afficher le message du palier actuel
      const remaining = Shopify.formatMoney(
        currentActiveTier.amount - cartPrice,
      moneyFormat
    );
      let messageText = String(currentActiveTier.text).replace(/\|\|amount\|\|/g, remaining);
      textToSet = replaceTierVariables(messageText, currentActiveTier);
    }
    messageElement.empty().text(textToSet);
    // Vider les autres instances pour éviter tout doublon affiché
    allMessageElements.not(messageElement).empty().text('');
  }
  
  // Créer et positionner les marqueurs de paliers sur la progress bar (équidistants)
  const markersContainer = $("[data-tier-markers]");
  if (markersContainer.length > 0) {
    markersContainer.empty();
    
    // Calculer la position pour chaque palier
    // Les marqueurs sont positionnés à équidistance des extrémités et rapprochés
    // Utiliser la même fonction getTierPosition que pour le calcul de la progress bar
  function getTierPosition(index, totalTiers) {
    if (totalTiers === 1) {
      // Si un seul palier, le positionner à 75% pour laisser de l'espace
      // La progress bar pourra atteindre 100% et dépasser le palier
      return 75;
      } else if (totalTiers === 2) {
        return index === 0 ? 25 : 75;
      } else if (totalTiers === 3) {
        return index === 0 ? 20 : (index === 1 ? 50 : 80);
      } else {
        const margin = 10;
        const availableWidth = 100 - (2 * margin);
        return margin + (index * availableWidth / (totalTiers - 1));
      }
    }
    
    // Si 3 paliers sont actifs, seul le palier du milieu (index 1) aura le texte au-dessus
    const hasThreeTiers = tiers.length === 3;
    
    tiers.forEach((tier, index) => {
      const tierReached = cartPrice >= tier.amount;
      
      // Utiliser la fonction getTierPosition pour être cohérent avec le calcul de la progress bar
      const tierPosition = getTierPosition(index, tiers.length);
      
      // Créer le marqueur avec cercle orange
      const marker = $('<div class="tier-marker"></div>');
      marker.css('left', tierPosition + '%');
      if (tierReached) {
        marker.addClass('tier-marker-reached');
      }
      // Ajouter une classe spéciale uniquement pour le palier du milieu (index 1) quand il y a 3 paliers
      if (hasThreeTiers && index === 1) {
        marker.addClass('tier-marker-3-tiers-middle');
      }
      
      // Créer le label avec la description
      const textLabel = $('<div class="tier-marker-text"></div>');
      // Positionner le texte au même endroit horizontalement que l'icône
      textLabel.css('left', tierPosition + '%');
      
      // Afficher directement le rewardText s'il existe, sinon le successText
      let displayText = '';
      if (tier.rewardText !== null && tier.rewardText !== undefined && String(tier.rewardText).trim() !== '') {
        // Afficher directement le texte de récompense
        displayText = String(tier.rewardText);
      } else if (tier.successText) {
        // Fallback sur le successText si pas de rewardText
        displayText = String(tier.successText);
      }
      
      // Remplacer les variables ||reward||, ||product|| et ||price||
      displayText = replaceTierVariables(displayText, tier);
      
      // Capitaliser le premier mot du texte seulement si le texte n'est pas vide
      if (displayText && displayText.trim() !== '') {
        try {
          displayText = capitalizeFirstWord(displayText);
        } catch (e) {
          // En cas d'erreur, garder le texte original
        }
      }
      textLabel.text(displayText || '');
      if (tierReached && tier === lastTier) {
        textLabel.addClass('tier-marker-success');
      }
      
      if (hasThreeTiers && index === 1) {
        const text = (displayText || '').trim();
        const TWO_LINES_THRESHOLD = 15;
      
        if (text.length >= TWO_LINES_THRESHOLD) {
          textLabel.addClass('tier-text-2-lines');
        } else {
          textLabel.removeClass('tier-text-2-lines');
        }
      }      
      
      // Créer le label avec le montant (format selon la currency)
      const amountLabel = $('<div class="tier-marker-amount"></div>');
      const formattedAmount = Shopify.formatMoney(tier.amount, moneyFormat);
      amountLabel.text(formattedAmount);
      // Positionner le prix au même endroit horizontalement que l'icône
      amountLabel.css('left', tierPosition + '%');
      
      // Créer le cercle avec l'icône
      const circle = $('<div class="tier-marker-circle"></div>');
      // Positionner l'icône au même endroit horizontalement que le marker
      circle.css('left', tierPosition + '%');
      const icon = $('<div class="tier-marker-icon"></div>');
      
      // Ajouter l'icône - utiliser uniquement l'image uploadée
      let iconHTML = '';
      if (tier.iconImage && tier.iconImage.trim() !== '') {
        // Vérifier si c'est un SVG pour utiliser la classe spéciale
        const isSVG = tier.iconImage.toLowerCase().includes('.svg');
        if (isSVG) {
          iconHTML = '<img src="' + tier.iconImage + '" alt="Icône palier" class="tier-icon-image tier-icon-svg-load" data-svg-url="' + tier.iconImage + '" loading="lazy">';
        } else {
          iconHTML = '<img src="' + tier.iconImage + '" alt="Icône palier" class="tier-icon-image" loading="lazy">';
        }
      } else {
        // Icône par défaut si aucune image n'est uploadée
        iconHTML = '<span class="tier-icon-text">?</span>';
      }
      icon.html(iconHTML);
      circle.append(icon);
      
      // Pour le palier du milieu (index 1) avec 3 paliers, inverser l'ordre : texte d'abord, puis prix, puis icône
      // Pour les autres cas, garder l'ordre normal : icône, prix, texte
      if (hasThreeTiers && index === 1) {
        marker.append(textLabel);
        marker.append(amountLabel);
        marker.append(circle);
      } else {
        marker.append(circle);
        marker.append(amountLabel);
        marker.append(textLabel);
      }
      
      markersContainer.append(marker);
    });
  }
  
  // Gérer l'affichage des produits cadeaux sera fait dans manageGiftProducts
}

// Plus besoin de convertir les SVG - on utilise maintenant un filtre CSS

// Variable pour éviter les boucles infinies lors de l'application des codes
let isApplyingDiscount = false;
let lastDiscountCheck = {};


function applyDiscountCode(code) {
  // Ajouter le code promo au panier via /cart/update.js
  // C'est la méthode recommandée par Shopify pour appliquer des codes promo via AJAX
  
  // Utiliser /cart/update.js avec le paramètre discount
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    data: {
      discount: code
    },
    dataType: 'json',
    success: function(cart) {
      // Réinitialiser le flag avant de mettre à jour
      isApplyingDiscount = false;
      lastCartPrice = cart.total_price;
      
      // Sauvegarder l'état de visibilité du container avant buildCart
      const shippingBarContainer = $("[data-free-shipping-container]");
      const wasVisible = shippingBarContainer.length > 0 && !shippingBarContainer.hasClass('hidden');
      
      // Mettre à jour le drawer
      if (typeof buildCart === 'function') {
        buildCart(cart, false); // Ne pas ouvrir le drawer automatiquement
      }
      
      // Mettre à jour la page panier si on est sur la page panier
      if (typeof cartPageUpdate === 'function' && $('[data-cart-wrapper]').length > 0) {
        cartPageUpdate(cart);
      } else {
        // Sinon, juste mettre à jour la progress bar
        if (wasVisible && shippingBarContainer.length > 0) {
          shippingBarContainer.removeClass('hidden');
        }
        isUpdatingTiers = false;
        freeShippingBar(cart);
      }
    },
    error: function(xhr, status, error) {
      isApplyingDiscount = false;
      
      // Même en cas d'erreur, essayer de recharger le panier
      setTimeout(() => {
        jQuery.getJSON(cartUrl, function(cart) {
          if (cart) {
            lastCartPrice = cart.total_price;
            const shippingBarContainer = $("[data-free-shipping-container]");
            const wasVisible = shippingBarContainer.length > 0 && !shippingBarContainer.hasClass('hidden');
            if (typeof buildCart === 'function') {
              buildCart(cart, false);
            }
            // Ne plus appeler cartPageUpdate ici pour éviter le rechargement complet
            // Le cart listener gérera la mise à jour via manageQuickAddProducts
            if (wasVisible && shippingBarContainer.length > 0) {
              shippingBarContainer.removeClass('hidden');
            }
            isUpdatingTiers = false;
            freeShippingBar(cart);
            
            // Déclencher l'événement cart:updated pour que manageQuickAddProducts soit appelé
            if (!isCartMutationInProgress) {
  document.dispatchEvent(new CustomEvent('cart:updated'));
}
          }
        });
      }, 500);
    }
  });
}

function removeDiscountCode(code) {
  // Retirer le code promo du panier
  // Utiliser /cart/update.js avec le paramètre discount vide
  
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    data: {
      discount: ''
    },
    dataType: 'json',
    success: function(cart) {
      // Réinitialiser le flag avant de mettre à jour
      isApplyingDiscount = false;
      lastCartPrice = cart.total_price;
      
      // Sauvegarder l'état de visibilité du container avant buildCart
      const shippingBarContainer = $("[data-free-shipping-container]");
      const wasVisible = shippingBarContainer.length > 0 && !shippingBarContainer.hasClass('hidden');
      
      // Mettre à jour le drawer
      if (typeof buildCart === 'function') {
        buildCart(cart, false); // Ne pas ouvrir le drawer automatiquement
      }
      
      // Mettre à jour la page panier si on est sur la page panier
      if (typeof cartPageUpdate === 'function' && $('[data-cart-wrapper]').length > 0) {
        cartPageUpdate(cart);
      } else {
        // Sinon, juste mettre à jour la progress bar
        if (wasVisible && shippingBarContainer.length > 0) {
          shippingBarContainer.removeClass('hidden');
        }
        isUpdatingTiers = false;
        freeShippingBar(cart);
      }
    },
    error: function(xhr, status, error) {
      // Même en cas d'erreur, essayer de recharger le panier
      setTimeout(() => {
        jQuery.getJSON(cartUrl, function(cart) {
          if (cart) {
            isApplyingDiscount = false;
            lastCartPrice = cart.total_price;
            
            const shippingBarContainer = $("[data-free-shipping-container]");
            const wasVisible = shippingBarContainer.length > 0 && !shippingBarContainer.hasClass('hidden');
            
            if (typeof buildCart === 'function') {
              buildCart(cart, false); // Ne pas ouvrir le drawer automatiquement
            }
            
            if (typeof cartPageUpdate === 'function' && $('[data-cart-wrapper]').length > 0) {
              cartPageUpdate(cart);
            } else {
              if (wasVisible && shippingBarContainer.length > 0) {
                shippingBarContainer.removeClass('hidden');
              }
              isUpdatingTiers = false;
              freeShippingBar(cart);
            }
          }
        });
      }, 500);
    }
  });
}

// Variable pour éviter les suppressions multiples de produits cadeaux
let isRemovingGiftProduct = false;
let isEnforcingGiftQuantity = false;

function getTierGiftProductIds(extraIds) {
  const ids = [];

  function pushId(id) {
    const parsed = parseInt(id, 10);
    if (parsed > 0 && !ids.includes(parsed)) {
      ids.push(parsed);
    }
  }

  if (typeof tier1ProductId !== 'undefined') pushId(tier1ProductId);
  if (typeof tier2ProductId !== 'undefined') pushId(tier2ProductId);
  if (typeof tier3ProductId !== 'undefined') pushId(tier3ProductId);

  if (extraIds && extraIds.length) {
    extraIds.forEach(pushId);
  }

  try {
    const stored = localStorage.getItem('cart_gift_product_ids');
    if (stored) {
      JSON.parse(stored).forEach(pushId);
    }
  } catch (e) {
    // Ignorer les erreurs de parsing
  }

  $('[data-tier-gifts-container] [data-product-id]').each(function () {
    pushId($(this).attr('data-product-id'));
  });

  return ids;
}

function isTierGiftProductId(productId) {
  return getTierGiftProductIds().includes(parseInt(productId, 10));
}

function getGiftProductTotalQuantity(cart, productId) {
  const pid = parseInt(productId, 10);
  if (!pid || !cart || !cart.items) return 0;

  return cart.items.reduce(function (total, item) {
    return parseInt(item.product_id, 10) === pid ? total + item.quantity : total;
  }, 0);
}

function enforceTierGiftQuantityLimits(cart) {
  if (!cart || !cart.items || isRemovingGiftProduct || isEnforcingGiftQuantity || isCartMutationInProgress) {
    return;
  }

  const giftIds = getTierGiftProductIds();

  for (let i = 0; i < giftIds.length; i++) {
    const giftId = giftIds[i];
    const matchingItems = cart.items.filter(function (item) {
      return parseInt(item.product_id, 10) === giftId;
    });

    if (!matchingItems.length) continue;

    const totalQty = matchingItems.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);

    if (totalQty <= 1 && matchingItems.length <= 1) {
      continue;
    }

    isEnforcingGiftQuantity = true;
    isRemovingGiftProduct = true;

    const primary = matchingItems[0];

    const finishEnforcement = function () {
      jQuery.getJSON(cartUrl, function (updatedCart) {
        isEnforcingGiftQuantity = false;
        isRemovingGiftProduct = false;
        enforceTierGiftQuantityLimits(updatedCart);
        updateTierGiftCartItemUi();
      });
    };

    if (primary.quantity > 1) {
      decreaseItemQuantity(primary.key, 1, finishEnforcement);
      return;
    }

    const extraItem = matchingItems[matchingItems.length - 1];
    if (matchingItems.length > 1 && extraItem) {
      removeItemFromCart(extraItem.key, finishEnforcement);
      return;
    }
  }
}

function updateTierGiftCartItemUi() {
  $('[data-cart-item][data-cart-item-product-id]').each(function () {
    const $row = $(this);
    const productId = parseInt($row.attr('data-cart-item-product-id'), 10);
    const isGift = isTierGiftProductId(productId);

    $row.toggleClass('tier-gift-cart-item', isGift);

    if (isGift) {
      $row.find('.quantity-up').prop('disabled', true).attr('aria-disabled', 'true');
      const $input = $row.find('[name="updates[]"]');
      if (parseInt($input.val(), 10) > 1) {
        $input.val(1);
      }
      $input.attr('max', '1');
    } else {
      $row.find('.quantity-up').prop('disabled', false).removeAttr('aria-disabled');
      $row.find('[name="updates[]"]').removeAttr('max');
    }
  });
}

// Lock global pour éviter les opérations panier concurrentes (source fréquente de loader infini)
let isCartMutationInProgress = false;

// Helper: sortir du mode loading même si le DOM a été reconstruit entre temps
function stopLoadingSafe($container) {
  try {
    if ($container && $container.length > 0) {
      $container.removeClass('loading');
    }
  } catch (e) {
    // noop
  }
}

// Retirer proprement des lignes panier via la key (stable)
function removeCartRowsByKeys(keys) {
  if (!keys || !keys.length) return;

  keys.forEach(function(key) {
    const $row = $(`[data-cart-item][data-cart-item-key="${key}"]`);
    if ($row.length) {
      $row.fadeOut(300, function() {
        $(this).remove();
      });
    }
  });
}

function manageGiftProducts(tiers, cartPrice, cart) {
  // Éviter les suppressions multiples
  if (isRemovingGiftProduct || isEnforcingGiftQuantity) {
    return;
  }

  const giftsContainer = $("[data-tier-gifts-container]");
  
  if (giftsContainer.length === 0) {
    return;
  }
  // Récupérer tous les productIds valides pour le marché actuel depuis les tiers
  // IMPORTANT : ne pas s'appuyer sur le DOM ici. Lors d'un changement de marché, le DOM
  // peut contenir des éléments (produits cadeaux) hérités du marché précédent, ce qui
  // empêcherait leur retrait du panier. La source de vérité doit être la configuration
  // "tiers" du marché actuel.
  const allValidGiftProductIds = tiers
    .filter(tier => tier.productId && tier.productId > 0)
    .map(tier => tier.productId);
  
  // Récupérer tous les productIds des variables globales (tier1ProductId, tier2ProductId, tier3ProductId)
  // Ces variables sont mises à jour selon le marché actuel
  const globalGiftProductIds = [];
  if (typeof tier1ProductId !== 'undefined' && tier1ProductId > 0) {
    globalGiftProductIds.push(tier1ProductId);
  }
  if (typeof tier2ProductId !== 'undefined' && tier2ProductId > 0) {
    globalGiftProductIds.push(tier2ProductId);
  }
  if (typeof tier3ProductId !== 'undefined' && tier3ProductId > 0) {
    globalGiftProductIds.push(tier3ProductId);
  }
  
  // Récupérer la liste des productIds de produits cadeaux stockée dans le localStorage
  // Cela permet de détecter les produits cadeaux d'un ancien marché
  let storedGiftProductIds = [];
  try {
    const stored = localStorage.getItem('cart_gift_product_ids');
    if (stored) {
      storedGiftProductIds = JSON.parse(stored);
    }
  } catch (e) {
    // Ignorer les erreurs de parsing
  }
  
  // Mettre à jour la liste stockée avec les productIds actuels
  const allKnownGiftProductIds = [...new Set([...globalGiftProductIds, ...storedGiftProductIds])];
  try {
    localStorage.setItem('cart_gift_product_ids', JSON.stringify(allKnownGiftProductIds));
  } catch (e) {
    // Ignorer les erreurs de localStorage
  }
  
  for (const item of cart.items) {
    // Vérifier si cet item correspond à un des productIds connus (produits cadeaux)
    const isKnownGiftProduct = allKnownGiftProductIds.some(function (giftId) {
      return parseInt(giftId, 10) === parseInt(item.product_id, 10);
    });

    // Vérifier si le produit est dans la liste des produits cadeaux valides pour le marché actuel
    const isInValidGiftList = allValidGiftProductIds.some(function (giftId) {
      return parseInt(giftId, 10) === parseInt(item.product_id, 10);
    });

    // Si c'est un produit cadeau connu mais qu'il n'est plus dans la liste valide, le retirer
    // Cela signifie qu'il était un produit cadeau d'un ancien marché qui n'est plus valide pour le marché actuel
    if (isKnownGiftProduct && !isInValidGiftList) {
      if (!isRemovingGiftProduct) {
        isRemovingGiftProduct = true;
        removeItemFromCart(item.key, () => {
          isRemovingGiftProduct = false;
          // Recharger le panier après suppression
          setTimeout(() => {
            jQuery.getJSON(cartUrl, function(updatedCart) {
              if (typeof buildCart === 'function' && $('[data-drawer-body]').length > 0) {
                buildCart(updatedCart, false);
              } else if (typeof cartPageUpdate === 'function' && $('[data-cart-wrapper]').length > 0) {
                cartPageUpdate(updatedCart);
              }
            });
          }, 300);
        });
        break; // Sortir de la boucle pour éviter de traiter plusieurs produits en même temps
      }
    }
  }

  
  tiers.forEach((tier) => {
    // Gérer les produits cadeaux (peuvent avoir un code promo associé)
    if (tier.productId && tier.productId > 0) {
      const productReached = cartPrice >= tier.amount;
      const productInCart = getGiftProductTotalQuantity(cart, tier.productId) > 0;
      
      // Chercher dans le container dédié
      const giftWrapper = giftsContainer.find(`[data-product-id="${tier.productId}"]`);
      
      if (productReached && !productInCart) {
        // Afficher le produit cadeau dans le container
        if (giftWrapper.length > 0) {
          giftWrapper.removeClass('hidden');
          // Mettre à jour l'attribut data-tier-id du bouton
          giftWrapper.find('.tier-add-gift-btn').attr('data-tier-id', tier.id);
        }
      } else if (!productReached) {
        // Masquer le produit cadeau
        if (giftWrapper.length > 0) {
          giftWrapper.addClass('hidden');
        }
        // Enlever le produit cadeau si le palier n'est plus atteint
        if (productInCart && !isRemovingGiftProduct) {
          const item = cart.items.find(function (cartItem) {
            return parseInt(cartItem.product_id, 10) === parseInt(tier.productId, 10);
          });
          if (item) {
            isRemovingGiftProduct = true;
            removeItemFromCart(item.key, function () {
              isRemovingGiftProduct = false;
            });
          }
        }
      } else if (productInCart) {
        // Si le produit est dans le panier et le palier est atteint, masquer le wrapper (déjà ajouté)
        if (giftWrapper.length > 0) {
          giftWrapper.addClass('hidden');
        }
      }
    }
    
  });
}

// Variable pour éviter les suppressions multiples de produits d'ajout rapide
let isRemovingQuickAddProduct = false;
// Variable pour suivre les produits qui viennent d'être ajoutés (pour éviter de les supprimer)
let recentlyAddedQuickAddProductIds = [];

function manageQuickAddProducts(cart) {
  // Éviter les suppressions multiples
  if (isRemovingQuickAddProduct) {
    return;
  }
  
  // Vérifier que jQuery est disponible et que le cart existe
  if (typeof $ === 'undefined' || !cart || !cart.items) {
    return;
  }
  
  // Attendre un peu pour que le DOM soit mis à jour après le changement de marché
  setTimeout(function() {
    // Récupérer le productId du produit d'ajout rapide actuel depuis la variable JavaScript exposée par Liquid
    // Cette variable est définie dans theme-scripts.liquid et utilise la même logique que main-cart.liquid
    let currentQuickAddProductId = null;
    
    // Utiliser la variable globale exposée par Liquid (définie dans theme-scripts.liquid)
    if (typeof window.currentQuickAddProductId !== 'undefined' && window.currentQuickAddProductId !== null && window.currentQuickAddProductId !== 0) {
      currentQuickAddProductId = window.currentQuickAddProductId;
    }
    
    // Récupérer la liste des productIds de produits d'ajout rapide stockée dans le localStorage
    let storedQuickAddProductIds = [];
    try {
      const stored = localStorage.getItem('cart_quick_add_product_ids');
      if (stored) {
        storedQuickAddProductIds = JSON.parse(stored);
      }
    } catch (e) {
      // Ignorer les erreurs de parsing
    }
    
    // Mettre à jour la liste stockée avec le productId actuel s'il existe
    // IMPORTANT : Faire cela AVANT de vérifier les produits à supprimer
    if (currentQuickAddProductId && currentQuickAddProductId > 0) {
      if (!storedQuickAddProductIds.includes(currentQuickAddProductId)) {
        storedQuickAddProductIds.push(currentQuickAddProductId);
      }
      try {
        localStorage.setItem('cart_quick_add_product_ids', JSON.stringify(storedQuickAddProductIds));
      } catch (e) {
        // Ignorer les erreurs de localStorage
      }
    }
    
    // Nettoyer la liste des produits récemment ajoutés (après 5 secondes)
    const now = Date.now();
    recentlyAddedQuickAddProductIds = recentlyAddedQuickAddProductIds.filter(function(entry) {
      return (now - entry.timestamp) < 5000; // Garder seulement ceux ajoutés il y a moins de 5 secondes
    });
    
    // Vérifier si un produit d'ajout rapide existe pour le marché actuel (via metaobjects)
    // Le module peut ne pas être dans le DOM si le produit est déjà dans le panier, mais on peut quand même vérifier via metaobjects
    const quickAddProductExists = (currentQuickAddProductId && currentQuickAddProductId > 0);
    
    // Vérifier si des produits d'ajout rapide dans le panier doivent être retirés
    cart.items.forEach((item) => {
      // Vérifier si cet item correspond à un des productIds connus (produits d'ajout rapide)
      const isKnownQuickAddProduct = storedQuickAddProductIds.includes(item.product_id);
      
      // Vérifier si cet item correspond au produit d'ajout rapide actuel (déterminé via metaobjects)
      const isCurrentQuickAddProduct = quickAddProductExists && (item.product_id === currentQuickAddProductId);
      
      // Vérifier si le produit vient d'être ajouté (dans les 5 dernières secondes)
      const isRecentlyAdded = recentlyAddedQuickAddProductIds.some(function(entry) {
        return entry.productId === item.product_id;
      });
      
      // Ne jamais supprimer :
      // 1. Le produit d'ajout rapide actuel (déterminé via metaobjects pour ce marché)
      // 2. Un produit qui vient d'être ajouté (dans les 5 dernières secondes)
      if (isCurrentQuickAddProduct || isRecentlyAdded) {
        return; // Passer au produit suivant sans supprimer
      }
      
      // Si c'est un produit d'ajout rapide connu, le retirer dans ces cas :
      // - Aucun produit d'ajout rapide n'existe pour ce marché (pas de metaobject correspondant)
      // - Le produit d'ajout rapide existe mais ce n'est pas le produit actuel (ancien produit d'un autre marché)
      if (isKnownQuickAddProduct && (!quickAddProductExists || !isCurrentQuickAddProduct)) {
        if (!isRemovingQuickAddProduct) {
          isRemovingQuickAddProduct = true;
          // Nettoyer le localStorage des productIds avant suppression
          const updatedStoredIds = storedQuickAddProductIds.filter(id => id !== item.product_id);
          try {
            localStorage.setItem('cart_quick_add_product_ids', JSON.stringify(updatedStoredIds));
          } catch (e) {
            // Ignorer les erreurs de localStorage
          }
          
          // Appeler removeItemFromCart qui va mettre à jour le panier et la page
          removeItemFromCart(item.key, () => {
            isRemovingQuickAddProduct = false;
            // Vérifier si on est sur la page panier
            const isCartPage = $('[data-cart-wrapper]').length > 0;
            
            // Forcer un rechargement complet de la page panier si on est sur la page panier
            if (isCartPage && typeof cartPageUpdate === 'function') {
              setTimeout(function() {
                jQuery.getJSON(cartUrl, function(freshCart) {
                  cartPageUpdate(freshCart);
                });
              }, 500);
            }
          });
          return; // Sortir de la boucle pour éviter de traiter plusieurs produits en même temps
        }
      }
    });
  }, 500); // Attendre 500ms pour que le DOM soit mis à jour
}

/**
 * Réinitialise l'UI du quick-add dans le drawer lorsque le produit n'est plus dans le panier.
 * Remet le toggle (texte d'ajout + chevron) et affiche à nouveau le contenu pliable.
 */
function resetQuickAddDrawerUIWhenProductRemoved(cart) {
  if (typeof $ === 'undefined' || !cart || !cart.items) {
    return;
  }
  const cartProductIds = cart.items.map(function (item) {
    return item.product_id;
  });
  const drawerBody = $('[data-drawer-body]');
  if (!drawerBody.length) {
    return;
  }
  drawerBody.find('.cart-quick-add-product[data-drawer-only]').each(function () {
    const $container = $(this);
    const quickAddProductId = parseInt($container.attr('data-quick-add-product-id'), 10);
    if (!quickAddProductId) {
      return;
    }
    if (cartProductIds.indexOf(quickAddProductId) !== -1) {
      return; // Le produit est encore dans le panier, ne rien faire
    }
    const $toggleSpan = $container.find('.leave-order-note > span').first();
    if (!$toggleSpan.length) {
      return;
    }
    if ($toggleSpan.hasClass('cart-quick-add-toggle')) {
      return; // Déjà en état "ajout", pas de réinitialisation
    }
    const $btn = $container.find('.cart-quick-add-btn');
    if (!$btn.length) {
      return;
    }
    let addText = $btn.attr('data-add-text') || '';
    const productName = $btn.attr('data-product-name') || '';
    const productPrice = $btn.attr('data-product-price') || '';
    addText = String(addText)
      .replace(/\|\|product\|\|/g, productName)
      .replace(/\|\|price\|\|/g, productPrice);
    const chevronSvg =
      '<svg class="cart-quick-add-icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 14px; height: 14px; transition: transform 0.3s ease; flex-shrink: 0;"><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"/></svg>';
    const toggleHtml =
      chevronSvg + '<span class="cart-quick-add-text">' + (addText || '') + '</span>';
    $toggleSpan.attr(
      'class',
      'cartDrawerNote cart-quick-add-toggle active'
    );
    $toggleSpan.attr(
      'style',
      'display: inline-flex; align-items: center; gap: 6px; cursor: pointer; background-color: white !important;'
    );
    $toggleSpan.html(toggleHtml);
    $container.find('.cart-quick-add-content').show();
    // Réactiver le bouton (il avait été désactivé lors de l'ajout au panier)
    $btn.prop('disabled', false).removeClass('is-loading');
    try {
      let storedIds = [];
      const stored = localStorage.getItem('cart_quick_add_product_ids');
      if (stored) {
        storedIds = JSON.parse(stored);
      }
      storedIds = storedIds.filter(function (id) {
        return id !== quickAddProductId;
      });
      localStorage.setItem('cart_quick_add_product_ids', JSON.stringify(storedIds));
    } catch (e) {
      // Ignorer les erreurs localStorage
    }
  });
}

function removeItemFromCart(itemKey, callback) {
  // Ajouter un loader sur le conteneur des produits
  const isCartPageRemove = $('[data-cart-wrapper]').length > 0;
  const productsContainerRemove = isCartPageRemove 
    ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
    : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
  if (productsContainerRemove.length > 0) {
    productsContainerRemove.addClass('loading');
  }
  
  // Trouver le line number depuis l'itemKey
  jQuery.getJSON(cartUrl, function(currentCart) {
    const item = currentCart.items.find(item => item.key === itemKey);
    if (!item) {
      // Retirer le loader si l'item n'existe pas
      if (productsContainerRemove.length > 0) {
        productsContainerRemove.removeClass('loading');
      }
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }
    
    // Vérifier si l'article à supprimer est un produit offert
    const isGiftProduct = currentCart.items.some(cartItem => 
      cartItem.key === itemKey && 
      (tier1ProductId > 0 && cartItem.product_id === tier1ProductId ||
       tier2ProductId > 0 && cartItem.product_id === tier2ProductId ||
       tier3ProductId > 0 && cartItem.product_id === tier3ProductId)
    );
    
    // Si ce n'est pas un produit offert, vérifier si on passe sous le palier
    if (!isGiftProduct) {
      // Calculer le prix du panier après suppression
      const priceAfterRemoval = currentCart.total_price - (item.final_line_price || item.line_price || 0);
      
      // Vérifier si on passe sous un palier
      let shouldRemoveGiftsFirst = false;
      const giftProductsToRemove = [];
      
      // Vérifier chaque palier
      if (tier1Enabled && tier1Amount > 0 && tier1ProductId > 0) {
        const wasReached = currentCart.total_price >= tier1Amount;
        const willBeReached = priceAfterRemoval >= tier1Amount;
        if (wasReached && !willBeReached) {
          const giftItem = currentCart.items.find(cartItem => cartItem.product_id === tier1ProductId);
          if (giftItem) {
            shouldRemoveGiftsFirst = true;
            giftProductsToRemove.push(giftItem);
          }
        }
      }
      
      if (tier2Enabled && tier2Amount > 0 && tier2ProductId > 0) {
        const wasReached = currentCart.total_price >= tier2Amount;
        const willBeReached = priceAfterRemoval >= tier2Amount;
        if (wasReached && !willBeReached) {
          const giftItem = currentCart.items.find(cartItem => cartItem.product_id === tier2ProductId);
          if (giftItem && !giftProductsToRemove.find(g => g.key === giftItem.key)) {
            shouldRemoveGiftsFirst = true;
            giftProductsToRemove.push(giftItem);
          }
        }
      }
      
      if (tier3Enabled && tier3Amount > 0 && tier3ProductId > 0) {
        const wasReached = currentCart.total_price >= tier3Amount;
        const willBeReached = priceAfterRemoval >= tier3Amount;
        if (wasReached && !willBeReached) {
          const giftItem = currentCart.items.find(cartItem => cartItem.product_id === tier3ProductId);
          if (giftItem && !giftProductsToRemove.find(g => g.key === giftItem.key)) {
            shouldRemoveGiftsFirst = true;
            giftProductsToRemove.push(giftItem);
          }
        }
      }
      
      // Si on doit retirer les produits offerts d'abord
      if (shouldRemoveGiftsFirst && giftProductsToRemove.length > 0) {
        // Empêcher les séquences concurrentes (changement de marché + listeners + double clic, etc.)
        if (isCartMutationInProgress) {
          return;
        }
        isCartMutationInProgress = true;

        // Retirer tous les items (produits offerts + produit original) séquentiellement
        // On doit les retirer un par un pour éviter les problèmes d'indices qui changent
        const allItemsToRemove = [...giftProductsToRemove];
        // Ajouter l'item original à la fin de la liste
        allItemsToRemove.push({ key: itemKey });

        // Fonction récursive pour retirer les items un par un
        function removeItemsSequentially(itemsToRemove, index, finalCallback) {
          if (index >= itemsToRemove.length) {
            // Tous les items ont été retirés
            if (typeof finalCallback === 'function') {
              finalCallback();
            }
            return;
          }

          const itemToRemove = itemsToRemove[index];

          // Récupérer le panier frais pour avoir le bon line number
          jQuery.getJSON(cartUrl, function (freshCart) {
            // Trouver l'item par son key (plus fiable que l'index)
            const item = freshCart.items.find(cartItem => cartItem.key === itemToRemove.key);

            if (!item) {
              // L'item n'existe plus, passer au suivant
              removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
              return;
            }

            // Trouver le line number actuel
            const line = freshCart.items.indexOf(item) + 1;

            if (line > 0) {
              // Retirer l'item
              $.ajax({
                url: cartChangeUrl,
                type: 'POST',
                data: 'quantity=0&line=' + line,
                dataType: 'json'
              })
                .always(function () {
                  // Passer au suivant (pas de setTimeout nécessaire ici : on s'appuie sur le callback ajax)
                  removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
                });
            } else {
              // Line number invalide, passer au suivant
              removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
            }
          }).fail(function () {
            // Si on ne peut pas lire le panier, on tente quand même de continuer la séquence
            removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
          });
        }

        // Démarrer le retrait séquentiel
        removeItemsSequentially(allItemsToRemove, 0, function () {
          // Tous les items ont été retirés, mettre à jour l'affichage
          jQuery.getJSON(cartUrl, function (finalCart) {
            // Mettre à jour le prix
            lastCartPrice = finalCart.total_price;

            // Mettre à jour le drawer
            if (typeof buildCart === 'function') {
              buildCart(finalCart, false);
            }

            // Mettre à jour la page panier si on est sur la page panier
            const isCartPage = $('[data-cart-wrapper]').length > 0;
            if (isCartPage) {
              // Retirer toutes les lignes qui ne correspondent plus à un item du panier (key-based)
              const finalKeys = finalCart.items.map(function(i) { return i.key; });
              const keysToRemove = [];
              $('[data-cart-item][data-cart-item-key]').each(function() {
                const key = $(this).attr('data-cart-item-key');
                if (key && !finalKeys.includes(key)) {
                  keysToRemove.push(key);
                }
              });
              removeCartRowsByKeys(keysToRemove);

              // Mise à jour simple des totaux (le DOM sera reconstruit par buildCart/cartPageUpdate ailleurs si besoin)
              const $totalPrice = getCartTotalPriceElements();
              if ($totalPrice.length > 0) {
                $totalPrice.text(Shopify.formatMoney(finalCart.total_price, moneyFormat));
              }

              syncCartOriginalTotalDisplay(finalCart, moneyFormat);
            }

            // Déverrouiller avant de notifier (sinon certains listeners repartent en boucle)
            isCartMutationInProgress = false;

            // Déclencher l'événement cart:updated UNE SEULE FOIS, après la fin de la séquence
            try {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            } catch (e) {
              // noop
            }

            // Retirer le loader (garanti)
            stopLoadingSafe(productsContainerRemove);

            // Appeler le callback
            if (typeof callback === 'function') {
              callback();
            }
          }).fail(function () {
            // Même si le refresh échoue, on sort du loader et on déverrouille
            isCartMutationInProgress = false;
            stopLoadingSafe(productsContainerRemove);
            if (typeof callback === 'function') {
              callback();
            }
          });
        });

        return; // Sortir ici, la suppression se fera via AJAX
      }
    }
    
    const line = currentCart.items.indexOf(item) + 1;

    // Utiliser cart/change.js avec line et quantity=0
    $.ajax({
      url: cartChangeUrl,
      type: 'POST',
      data: 'quantity=0&line=' + line,
      dataType: 'json',
      success: function(cart) {
        // Mettre à jour le prix pour éviter les appels multiples
        lastCartPrice = cart.total_price;
        
        // Sauvegarder l'état de visibilité du container avant buildCart
        const shippingBarContainer = $("[data-free-shipping-container]");
        const wasVisible = shippingBarContainer.length > 0 && !shippingBarContainer.hasClass('hidden');
        
        // Mettre à jour le drawer
        if (typeof buildCart === 'function') {
          buildCart(cart, false); // Ne pas ouvrir le drawer automatiquement
        }
        
        // Mettre à jour la page panier si on est sur la page panier
        const isCartPage = $('[data-cart-wrapper]').length > 0;
        if (isCartPage) {
          // Retirer la ligne produit du DOM et mettre à jour le total
          // Trouver la ligne à retirer en utilisant l'itemKey
          jQuery.getJSON(cartUrl, function(freshCart) {
            lastCartPrice = freshCart.total_price;

            // Re-render complet de la page panier (prix ligne + total + data-line alignés)
            if (typeof cartPageUpdate === 'function') {
              cartPageUpdate(freshCart);
            } else {
              const $totalPrice = getCartTotalPriceElements();
              if ($totalPrice.length > 0) {
                $totalPrice.text(Shopify.formatMoney(freshCart.total_price, moneyFormat));
              }

              syncCartOriginalTotalDisplay(freshCart, moneyFormat);

              // Retirer les rows obsolètes (key-based)
              const finalKeys = freshCart.items.map(function(i) { return i.key; });
              const keysToRemove = [];
              $('[data-cart-item][data-cart-item-key]').each(function() {
                const key = $(this).attr('data-cart-item-key');
                if (key && !finalKeys.includes(key)) keysToRemove.push(key);
              });
              removeCartRowsByKeys(keysToRemove);
            }

            if (!isCartMutationInProgress) {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }

            stopLoadingSafe(productsContainerRemove);

            // Callback seulement à la fin
            if (typeof callback === 'function') {
              callback();
            }
          }).fail(function() {
            stopLoadingSafe(productsContainerRemove);
            if (!isCartMutationInProgress) {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }
            if (typeof callback === 'function') {
              callback();
            }
          });
        } else {
          // Pour le drawer, attendre que buildCart ait fini de charger le HTML
          // buildCart charge le HTML via AJAX, donc on doit attendre
          setTimeout(function() {
            if (cart.item_count > 0 && shippingBarContainer.length > 0) {
              shippingBarContainer.removeClass('hidden');
            }
            isUpdatingTiers = false;
            lastCartPrice = cart.total_price;
            // Attendre encore un peu pour que le DOM soit complètement chargé
            setTimeout(function() {
              freeShippingBar(cart);
              // Callback seulement à la fin
              if (typeof callback === 'function') {
                callback();
              }
            }, 300);
          }, 500);
        }
      },
      error: function(xhr, status, error) {
        // Si erreur, récupérer le panier directement pour vérifier l'état
        jQuery.getJSON(cartUrl, function(cart) {
          // Mettre à jour la page panier si on est sur la page panier
          if (typeof cartPageUpdate === 'function' && $('[data-cart-wrapper]').length > 0) {
            cartPageUpdate(cart);
          } else {
            // Mettre à jour le drawer
            if (typeof buildCart === 'function') {
              buildCart(cart, false);
            }
          }
          // Réinitialiser le flag
          if (typeof callback === 'function') {
            callback();
          }
        }).fail(function() {
          // Si même la récupération échoue, réinitialiser quand même le flag
          if (typeof callback === 'function') {
            callback();
          }
        });
      }
    });
  });
}

// Fonction pour réduire la quantité d'un produit au lieu de le retirer complètement
function decreaseItemQuantity(itemKey, newQuantity, callback) {
  // Ajouter un loader sur le conteneur des produits
  const isCartPageDecrease = $('[data-cart-wrapper]').length > 0;
  const productsContainerDecrease = isCartPageDecrease 
    ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
    : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
  if (productsContainerDecrease.length > 0) {
    productsContainerDecrease.addClass('loading');
  }
  
  // Trouver le line number depuis l'itemKey
  jQuery.getJSON(cartUrl, function(currentCart) {
    const item = currentCart.items.find(item => item.key === itemKey);
    if (!item) {
      // Retirer le loader si l'item n'existe pas
      if (productsContainerDecrease.length > 0) {
        productsContainerDecrease.removeClass('loading');
      }
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }
    
    const line = currentCart.items.indexOf(item) + 1;
    
    // Utiliser cart/change.js avec line et quantity
    $.ajax({
      url: cartChangeUrl,
      type: 'POST',
      data: 'quantity=' + newQuantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
        // Mettre à jour le prix pour éviter les appels multiples
        lastCartPrice = cart.total_price;
        
        // Sauvegarder l'état de visibilité du container avant buildCart
        const shippingBarContainer = $("[data-free-shipping-container]");
        const wasVisible = shippingBarContainer.length > 0 && !shippingBarContainer.hasClass('hidden');
        
        // Mettre à jour la page panier si on est sur la page panier
        const isCartPage = $('[data-cart-wrapper]').length > 0;

        if (isCartPage) {
          // Sur page panier, on se base sur le panier frais et on rend via cartPageUpdate
          jQuery.getJSON(cartUrl, function(freshCart) {
            lastCartPrice = freshCart.total_price;

            // Source de vérité UI : re-render complet (prix ligne + total + etc.)
            if (typeof cartPageUpdate === 'function') {
              cartPageUpdate(freshCart);
            } else {
              // Fallback minimal si cartPageUpdate n'existe pas
              const $totalPrice = getCartTotalPriceElements();
              if ($totalPrice.length > 0) {
                $totalPrice.text(Shopify.formatMoney(freshCart.total_price, moneyFormat));
              }

              syncCartOriginalTotalDisplay(freshCart, moneyFormat);
            }

            // Déclencher l'événement cart:updated
            if (!isCartMutationInProgress) {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }

            // Retirer le loader
            stopLoadingSafe(productsContainerDecrease);

            // Appeler le callback A LA FIN (évite des chevauchements)
            if (typeof callback === 'function') {
              callback();
            }
          }).fail(function() {
            // Même si le refresh échoue, on sort du loader
            stopLoadingSafe(productsContainerDecrease);
            if (!isCartMutationInProgress) {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }
            if (typeof callback === 'function') {
              callback();
            }
          });

        } else {
          // Drawer uniquement
          if (typeof buildCart === 'function') {
            buildCart(cart, false);
          }

          // Pour le drawer, attendre que buildCart ait fini de charger le HTML
          setTimeout(function() {
            if (cart.item_count > 0 && shippingBarContainer.length > 0) {
              shippingBarContainer.removeClass('hidden');
            }
            isUpdatingTiers = false;
            lastCartPrice = cart.total_price;

            // Retirer le loader
            stopLoadingSafe(productsContainerDecrease);

            // Attendre encore un peu pour que le DOM soit complètement chargé
            setTimeout(function() {
              freeShippingBar(cart);
            }, 300);

            if (typeof callback === 'function') {
              callback();
            }
          }, 500);
        }
      },
      error: function(xhr, status, error) {
        // Retirer le loader en cas d'erreur
        if (productsContainerDecrease.length > 0) {
          productsContainerDecrease.removeClass('loading');
        }
        // Si erreur, récupérer le panier directement pour vérifier l'état
        jQuery.getJSON(cartUrl, function(cart) {
          // Mettre à jour la page panier si on est sur la page panier
          if (typeof cartPageUpdate === 'function' && $('[data-cart-wrapper]').length > 0) {
            cartPageUpdate(cart);
          } else {
            // Mettre à jour le drawer
            if (typeof buildCart === 'function') {
              buildCart(cart, false);
            }
          }
          // Réinitialiser le flag
          if (typeof callback === 'function') {
            callback();
          }
        }).fail(function() {
          // Si même la récupération échoue, réinitialiser quand même le flag
          if (typeof callback === 'function') {
            callback();
          }
        });
      }
    });
  });
}

// Gérer le clic sur le bouton d'ajout du produit cadeau
$(document).on('click', '.tier-add-gift-btn', function(e) {
  e.preventDefault();
  const button = $(this);
  const productId = parseInt(button.attr('data-product-id'), 10);
  const variantId = parseInt(button.attr('data-variant-id'), 10);
  const tierId = button.data('tier-id') || button.data('tier');
  
  if (!productId || !variantId) {
    return;
  }
  
  // Éviter les clics multiples
  if (button.hasClass('is-loading')) {
    return;
  }
  
  button.addClass('is-loading').prop('disabled', true);
  
  // Ajouter un loader sur le conteneur des produits
  const isCartPageGift = $('[data-cart-wrapper]').length > 0;
  const productsContainerGift = isCartPageGift 
    ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
    : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
  if (productsContainerGift.length > 0) {
    productsContainerGift.addClass('loading');
  }
  
    // Vérifier d'abord si le produit est déjà dans le panier
    jQuery.getJSON(cartUrl, function(cart) {
      const totalGiftQty = getGiftProductTotalQuantity(cart, productId);
      
      // Un seul exemplaire par produit cadeau
      if (totalGiftQty >= 1) {
        button.removeClass('is-loading').prop('disabled', true);
        setTimeout(function() {
          if (productsContainerGift.length > 0) {
            productsContainerGift.removeClass('loading');
          }
        }, 300);
        return;
      }
      
      // Ajouter le produit au panier (quantité = 1 maximum)
      $.ajax({
        url: cartAddUrl,
        type: 'POST',
        data: {
          id: variantId,
          quantity: 1,
          properties: {
            _tier_gift: 'true'
          }
        },
        dataType: 'json',
        success: function(item) {
          // Recharger le panier après l'ajout
          reloadCartAfterGiftAdd(button);
        },
      error: function(xhr, status, error) {
        // Retirer le loader en cas d'erreur
        if (productsContainerGift.length > 0) {
          productsContainerGift.removeClass('loading');
        }
        button.removeClass('is-loading').prop('disabled', false);
        alert('Erreur lors de l\'ajout du produit cadeau');
      }
    });
  });
});

// Fonction helper pour recharger le panier après l'ajout d'un produit cadeau
function setTierGiftAddButtonState(button, cart) {
  if (!button || !button.length) return;

  const productId = parseInt(button.attr('data-product-id'), 10);
  const inCart = getGiftProductTotalQuantity(cart, productId) >= 1;
  button.removeClass('is-loading').prop('disabled', inCart);
}

function reloadCartAfterGiftAdd(button) {
  jQuery.getJSON(cartUrl, function (cart) {
    // Mettre à jour le prix pour éviter les appels multiples
    lastCartPrice = cart.total_price;
    
    // S'assurer que le container de la progress bar est visible
    const shippingBarContainer = $("[data-free-shipping-container]");
    if (cart.item_count > 0 && shippingBarContainer.length > 0) {
      shippingBarContainer.removeClass('hidden');
    }
    
    // Mettre à jour le drawer
    if (typeof buildCart === 'function') {
      buildCart(cart, false); // Ne pas ouvrir le drawer automatiquement
    }
    
    // Mettre à jour la page panier si on est sur la page panier
    const isCartPageGiftReload = $('[data-cart-wrapper]').length > 0;
    const productsContainerGiftReload = isCartPageGiftReload 
      ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
      : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
    
    if (typeof cartPageUpdate === 'function' && isCartPageGiftReload) {
      cartPageUpdate(cart);
      // Retirer le loader après la mise à jour
      setTimeout(function() {
        if (productsContainerGiftReload.length > 0) {
          productsContainerGiftReload.removeClass('loading');
        }
        // S'assurer que le container est toujours visible après la mise à jour
        if (cart.item_count > 0 && shippingBarContainer.length > 0) {
          shippingBarContainer.removeClass('hidden');
        }
        // Forcer la réinitialisation du flag pour permettre l'exécution
        isUpdatingTiers = false;
        lastCartPrice = 0;
        freeShippingBar(cart);
        setTierGiftAddButtonState(button, cart);
      }, 300);
    } else {
      // Pour le drawer, attendre un peu pour que le DOM soit mis à jour
      setTimeout(function() {
        // Retirer le loader après la mise à jour
        if (productsContainerGiftReload.length > 0) {
          productsContainerGiftReload.removeClass('loading');
        }
        // S'assurer que le container est toujours visible
        if (cart.item_count > 0 && shippingBarContainer.length > 0) {
          shippingBarContainer.removeClass('hidden');
        }
        // Réinitialiser le flag AVANT d'appeler freeShippingBar
        isUpdatingTiers = false;
        lastCartPrice = cart.total_price;
        freeShippingBar(cart);
        setTierGiftAddButtonState(button, cart);
      }, 200);
    }
  }).fail(function() {
    // Retirer le loader en cas d'erreur
    const isCartPageGiftFail = $('[data-cart-wrapper]').length > 0;
    const productsContainerGiftFail = isCartPageGiftFail 
      ? $('[data-cart-wrapper] .yv-cart-table')
      : $('[data-drawer-body] [data-cart-products-container]');
    if (productsContainerGiftFail.length > 0) {
      productsContainerGiftFail.removeClass('loading');
    }
    button.removeClass('is-loading').prop('disabled', false);
  });
}

var favicon = false;
function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}
$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  // Utiliser le montant du premier palier si disponible
  if (tier1Enabled && tier1Amount > 0) {
    if (Shopify.currency.active != shopCurrency) {
      let shippingAmount = parseInt(tier1Amount);
      if (shippingAmount != undefined) {
        convertShippingAmount = parseFloat(
          (shippingAmount * Shopify.currency.rate).toFixed(2)
        );
      }
    }
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});
$(document).on("keyup ", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function (result) {},
    });
  }, 750);
});
if (/\/cart$/.test(window.location.pathname)) {
  // Shipping Estimations

  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");
        if (!country) {
          return false;
        }
        var shipping = new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "shippingProvince",
          {
            hideElement: "shippingProvinceContainer",
          }
        );

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#ShippingWrapperResponse")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          var shippingAddress = {};
          shippingAddress.zip = jQuery("#shippingZip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#shippingProvince").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };
    var _onError = function (XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#ShippingWrapperResponse")
        .html('<p class="error-text">' + feedback + "</p>")
        .addClass("error")
        .show();
    };
    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#ShippingWrapperResponse").html(html).addClass("success").show();
      } else {
        $("#ShippingWrapperResponse")
          .html('<p class="error-text">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };
    setTimeout(function () {
      shippingEstimates();
      $.ajax({
        url: mainCartUrl,
        type: "GET",
        dataType: "json",
        success: function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            upsellCartProducts(result)
          }
        },
      });
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();

  // Discount Code Application
  (function () {
    // Délégation jQuery pour que les boutons fonctionnent dans le drawer (contenu chargé en AJAX)
    $(document).on("click", "[data-close-details]", function(e) {
      e.preventDefault();
      var id = $(this).attr("data-close-details");
      var details = id ? document.getElementById(id) : null;
      if (details) details.removeAttribute("open");
      var input = details ? details.querySelector(".discount-code-input") : null;
      if (input) input.value = "";
    });

    $(document).on("click", ".yv-discount-code-apply", function(e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.prop("disabled")) return;
      var inputId = $btn.attr("data-discount-input-id");
      var responseId = $btn.attr("data-discount-response-id");
      if (!inputId || !responseId) return;
      var inputEl = document.getElementById(inputId);
      var code = inputEl ? inputEl.value.trim() : "";
      if (code) applyDiscountCodeFromInput(code, responseId);
    });

    $(document).on("keydown", ".discount-code-input", function(e) {
      if (e.key !== "Enter") return;
      e.preventDefault();
      var input = e.target;
      var code = input.value.trim();
      var responseId = input.id === "discountCodeSidecart" ? "DiscountCodeWrapperResponseSidecart" : "DiscountCodeWrapperResponse";
      if (code) applyDiscountCodeFromInput(code, responseId);
    });

    // Empêcher la soumission du formulaire panier quand le code promo est saisi : tout en AJAX, pas de rechargement
    $(document).on("submit", "#cart", function(e) {
      var form = e.target;
      var discountInput = form && form.querySelector ? form.querySelector(".discount-code-input, #discountCode, [name='discount_code']") : null;
      if (discountInput && discountInput.value && discountInput.value.trim()) {
        e.preventDefault();
        e.stopPropagation();
        var code = discountInput.value.trim();
        applyDiscountCodeFromInput(code, "DiscountCodeWrapperResponse");
        return false;
      }
    });

    function setupDiscountCodeListeners() {
      // Les clics sur Appliquer et Annuler sont gérés en délégation ci-dessus.
      // On garde setupDiscountCodeListeners pour les autres usages (ex. displayAppliedDiscountCodes).
    }

    function applyDiscountCodeFromInput(code, responseElementId) {
      var responseElement = document.getElementById(responseElementId);
      if (responseElement) {
        responseElement.innerHTML = "";
        responseElement.removeAttribute("class");
        responseElement.style.display = "none";
      }

      // Réinitialiser l'état visuel des champs de saisie
      var cartInput = document.getElementById("discountCode");
      var sidecartInput = document.getElementById("discountCodeSidecart");
      if (cartInput) cartInput.classList.remove("error");
      if (sidecartInput) sidecartInput.classList.remove("error");

      // Désactiver le bouton pendant le traitement
      var applyButton = document.getElementById("applyDiscountCode") || document.getElementById("applyDiscountCodeSidecart");
      if (applyButton) {
        // Sauvegarder le texte original
        if (!applyButton.getAttribute('data-original-text')) {
          applyButton.setAttribute('data-original-text', applyButton.textContent);
        }
        applyButton.disabled = true;
        applyButton.textContent = "Application...";
      }

      // Utiliser la fonction applyDiscountCode existante mais avec un callback pour afficher le résultat
      applyDiscountCodeWithCallback(code, function(success, messageOrEntry) {
        var isCartPage = $('[data-cart-wrapper]').length > 0;
        var responseElementSidecart = document.getElementById("DiscountCodeWrapperResponseSidecart");
        var cartInput = document.getElementById("discountCode");
        var sidecartInput = document.getElementById("discountCodeSidecart");

        if (responseElement) {
          if (success) {
            responseElement.innerHTML = '';
            responseElement.removeAttribute("class");
            responseElement.style.display = "none";
            if (cartInput && responseElementId === "DiscountCodeWrapperResponse") {
              cartInput.classList.remove("error");
            }
            if (sidecartInput && responseElementId === "DiscountCodeWrapperResponseSidecart") {
              sidecartInput.classList.remove("error");
            }
            if (responseElementId === "DiscountCodeWrapperResponse") {
              var detailsEl = document.getElementById("discount_code_details");
              if (detailsEl) detailsEl.setAttribute("open", "");
            }
          } else {
            responseElement.innerHTML = '<p class="error-text">' + messageOrEntry + '</p>';
            responseElement.className = "col-12 form-group error";
            responseElement.style.display = "block";
            if (cartInput && responseElementId === "DiscountCodeWrapperResponse") {
              cartInput.classList.add("error");
            }
            if (sidecartInput && responseElementId === "DiscountCodeWrapperResponseSidecart") {
              sidecartInput.classList.add("error");
            }
          }
          if (isCartPage && responseElementSidecart) {
            responseElementSidecart.innerHTML = '';
            responseElementSidecart.style.display = "none";
          }
        }
        
        if (!isCartPage && responseElementSidecart) {
          if (success) {
            responseElementSidecart.innerHTML = '';
            responseElementSidecart.removeAttribute("class");
            responseElementSidecart.style.display = "none";
            if (sidecartInput) {
              sidecartInput.classList.remove("error");
            }
          } else {
            responseElementSidecart.innerHTML = '<p class="error-text">' + messageOrEntry + '</p>';
            responseElementSidecart.className = "col-12 form-group error";
            responseElementSidecart.style.display = "block";
            if (sidecartInput) {
              sidecartInput.classList.add("error");
            }
          }
          if (responseElement) {
            responseElement.innerHTML = '';
            responseElement.style.display = "none";
            if (cartInput) {
              cartInput.classList.remove("error");
            }
          }
        }

        if (applyButton) {
          applyButton.disabled = false;
          var buttonText = applyButton.getAttribute('data-original-text') || 'Appliquer';
          applyButton.textContent = buttonText;
        }

        // Mettre à jour l'affichage du panier en AJAX sans recharger la page
        setTimeout(function() {
          jQuery.getJSON(cartUrl, function(cart) {
            if (isCartPage && typeof cartPageUpdate === 'function') {
              // Re-render complet : garantit le bon retrait/affichage des badges
              // de réduction ligne produit (nom + icône), surtout sur mobile.
              cartPageUpdate(cart);
            } else {
              if (typeof updateCartTotalsAndDiscountsFromCart === 'function') {
                updateCartTotalsAndDiscountsFromCart(cart);
              } else {
                displayAppliedDiscountCodes(cart);
                if (typeof buildCart === 'function') buildCart(cart, false);
                if (typeof freeShippingBar === 'function') freeShippingBar(cart);
              }
            }
            // Code appliqué avec succès mais produit associé absent : ajouter le produit au panier automatiquement
            if (success && window.promoProductByCode && isCartPage) {
              var codeKey = code.trim().toUpperCase();
              var promoEntry = window.promoProductByCode[codeKey];
              if (promoEntry && promoEntry.product_id && promoEntry.variant_id) {
                var productInCart = cart.items && cart.items.some(function(item) { return item.product_id === promoEntry.product_id; });
                if (!productInCart) {
                  $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    data: { id: promoEntry.variant_id, quantity: 1 },
                    dataType: 'json',
                    success: function() {
                      jQuery.getJSON(cartUrl, function(cart2) {
                        if (isCartPage && typeof cartPageUpdate === 'function') {
                          cartPageUpdate(cart2);
                        } else {
                          if (typeof updateCartTotalsAndDiscountsFromCart === 'function') {
                            updateCartTotalsAndDiscountsFromCart(cart2);
                          } else {
                            displayAppliedDiscountCodes(cart2);
                            if (typeof buildCart === 'function') buildCart(cart2, false);
                            if (typeof freeShippingBar === 'function') freeShippingBar(cart2);
                          }
                        }
                      });
                    }
                  });
                }
              }
            }
          });
        }, 300);
      });
    }

    function showPromoProductPopin(entry) {
      var popin = document.getElementById("promo-product-popin");
      if (!popin) return;
      var messageEl = document.getElementById("promo-product-popin-message");
      var linkEl = document.getElementById("promo-product-popin-link");
      var imgEl = document.getElementById("promo-product-popin-image");
      var titleEl = document.getElementById("promo-product-popin-title");
      var addBtn = document.getElementById("promo-product-popin-add");
      if (!messageEl || !linkEl || !imgEl || !titleEl || !addBtn) return;
      var message = (typeof window.promoPopinMessage === 'string') ? window.promoPopinMessage : "Ce code est associé à un produit. Souhaitez-vous l'ajouter à votre panier ?";
      messageEl.textContent = message;
      linkEl.href = entry.product_url || "#";
      imgEl.src = entry.product_image || "";
      imgEl.alt = entry.product_title || "";
      titleEl.textContent = entry.product_title || "";
      addBtn.setAttribute("data-variant-id", String(entry.variant_id));
      popin.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
    }

    function hidePromoProductPopin() {
      var popin = document.getElementById("promo-product-popin");
      if (popin) {
        popin.setAttribute("hidden", "");
        document.body.style.overflow = "";
      }
    }

    $(document).on("click", ".yv-promo-popin-close, .yv-promo-popin-backdrop", hidePromoProductPopin);
    $(document).on("click", "#promo-product-popin-add", function() {
      var btn = document.getElementById("promo-product-popin-add");
      if (!btn || btn.disabled) return;
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;
      btn.disabled = true;
      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        data: { id: variantId, quantity: 1 },
        dataType: "json",
        success: function() {
          hidePromoProductPopin();
          jQuery.getJSON(cartUrl, function(cart) {
            displayAppliedDiscountCodes(cart);
            if (typeof cartPageUpdate === 'function') cartPageUpdate(cart);
          });
        },
        error: function() { btn.disabled = false; }
      });
    });

    // Mise à jour partielle du panier (totaux + lignes de réduction + codes appliqués) sans recharger la page
    function updateCartTotalsAndDiscountsFromCart(cart) {
      if (!$('[data-cart-wrapper]').length) return;
      var fmt = typeof moneyFormat !== 'undefined' ? moneyFormat : '';
      var $totalPrice = getCartTotalPriceElements();
      if ($totalPrice.length && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        $totalPrice.text(Shopify.formatMoney(cart.total_price, fmt));
      }
      syncCartOriginalTotalDisplay(cart, fmt);
      var $pageSummaryUl = $('[data-cart-page-summary]');
      var $totalRow = $pageSummaryUl.find('[data-cart-total]').first();
      if ($pageSummaryUl.length && $totalRow.length) {
        $pageSummaryUl.find('[data-cart-discount]').remove();
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          var discountLabel = (typeof translations !== 'undefined' && translations.cart && translations.cart.discount) ? translations.cart.discount : 'Discount';
          cart.cart_level_discount_applications.forEach(function(discount) {
            var html = '<li class="text-medium" data-cart-discount><span>' + discountLabel + '[\'' + (discount.title || '') + '\']</span><strong>-' + (typeof Shopify !== 'undefined' && Shopify.formatMoney ? Shopify.formatMoney(discount.total_allocated_amount, fmt) : discount.total_allocated_amount) + '</strong></li>';
            $totalRow.before(html);
          });
        }
      }
      // Mettre à jour les prix des lignes produits (zone produit du panier)
      if (cart.items && cart.items.length > 0 && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        cart.items.forEach(function(cartItem, index) {
          var itemLine = index + 1;
          var $itemRow = $('[data-cart-item-key="' + cartItem.key + '"]');
          if ($itemRow.length === 0) {
            $itemRow = $('[data-line="' + itemLine + '"]').closest('tr, .media-link');
          }
          var priceBoxes = $itemRow.find('.yv-prizebox');
          priceBoxes.each(function() {
            var $priceBox = $(this);
            var $priceSpan = $priceBox.find('.yv-product-price');
            var $comparePriceSpan = $priceBox.find('.yv-product-compare-price');
            if ($priceSpan.length > 0) {
              var newPrice = cartItem.final_line_price === 0 ?
                ($priceSpan.text().indexOf('Free') !== -1 ? $priceSpan.text() : 'Free') :
                Shopify.formatMoney(cartItem.final_line_price, fmt);
              $priceSpan.text(newPrice);
            }
            if (cartItem.original_line_price !== cartItem.final_line_price) {
              if ($comparePriceSpan.length === 0) {
                $priceBox.append('<span class="yv-product-compare-price"></span>');
              }
              $priceBox.find('.yv-product-compare-price').text(Shopify.formatMoney(cartItem.original_line_price, fmt));
            } else {
              $priceBox.find('.yv-product-compare-price').remove();
            }
          });
          // Mettre à jour la liste des réductions sous les prix (icône + code sur la même ligne)
          var $discountList = $itemRow.find('[data-item-discount-list]');
          if ($discountList.length) {
            var discountHtml = '';
            if (cartItem.discounts && cartItem.discounts.length > 0) {
              var discountIconSvg = '<svg x="0px" y="0px" width="15" height="15" viewBox="0 0 15 15" aria-hidden="true"><path d="M2.1,0.2c-1,0-1.9,0.8-1.9,1.9v4.7c0,0.5,0.2,0.9,0.5,1.3l6.2,6.2c0.7,0.7,1.9,0.7,2.7,0l4.6-4.6c0.7-0.7,0.7-1.9,0-2.7L8.1,0.8C7.7,0.4,7.2,0.2,6.8,0.2L2.1,0.2z M3.7,5.4c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C5.4,4.6,4.6,5.4,3.7,5.4z"/></svg>';
              for (var d = 0; d < cartItem.discounts.length; d++) {
                var title = (cartItem.discounts[d].title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                discountHtml += '<li class="discounts__discount coupanName">' + discountIconSvg + '<small class="item__discount">' + title + '</small></li>';
              }
            }
            $discountList.html(discountHtml);
          }
        });
      }
      if (typeof displayAppliedDiscountCodes === 'function') {
        displayAppliedDiscountCodes(cart);
      }
      if (typeof freeShippingBar === 'function') {
        freeShippingBar(cart);
      }
    }

    // Fonction pour afficher les codes promo appliqués
    function displayAppliedDiscountCodes(cart) {
      // Pour la page panier
      var appliedContainer = document.getElementById("DiscountCodesApplied");
      var appliedContainerSidecart = document.getElementById("DiscountCodesAppliedSidecart");
      
      var appliedCodes = [];
      if (cart.discount_codes) {
        cart.discount_codes.forEach(function(discount) {
          if (discount.applicable === true) {
            appliedCodes.push(discount.code);
          }
        });
      }
      
      // Si aucun code appliqué, cacher les containers
      if (appliedCodes.length === 0) {
        if (appliedContainer) appliedContainer.innerHTML = '';
        if (appliedContainerSidecart) appliedContainerSidecart.innerHTML = '';
        return;
      }
      
      var appliedLabel = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.applied) ? discountCodeMessages.applied : 'Appliqué';
      var removeLabel = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.remove) ? discountCodeMessages.remove : 'Supprimer';
      var tagsHTML = '';
      appliedCodes.forEach(function(code) {
        tagsHTML += '<div class="yv-discount-code-applied-line">';
        tagsHTML += '<span class="yv-discount-code-applied-left"><span class="yv-discount-code-applied-code">' + code + '</span><span class="yv-discount-code-applied-status">| ' + appliedLabel + '</span></span>';
        tagsHTML += '<button type="button" class="yv-discount-code-remove remove-discount-code" data-code="' + code + '">' + removeLabel + '</button>';
        tagsHTML += '</div>';
      });
      
      if (appliedContainer) {
        appliedContainer.innerHTML = tagsHTML;
      }
      if (appliedContainerSidecart) {
        appliedContainerSidecart.innerHTML = tagsHTML;
      }
      
      // Ajouter les event listeners pour les boutons de suppression
      document.querySelectorAll('.remove-discount-code').forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          var codeToRemove = this.getAttribute('data-code');
          removeDiscountCodeFromInput(codeToRemove);
        });
      });
    }
    
    // Fonction pour retirer un code promo depuis l'interface (un seul code : envoi la liste des codes restants)
    function removeDiscountCodeFromInput(codeToRemove) {
      var codeToRemoveNorm = (codeToRemove || '').trim();
      if (!codeToRemoveNorm) return;
      
      $.getJSON(cartUrl, function(currentCart) {
        var remaining = [];
        if (currentCart.discount_codes) {
          currentCart.discount_codes.forEach(function(d) {
            if (d.applicable === true && d.code && d.code.toLowerCase() !== codeToRemoveNorm.toLowerCase()) {
              remaining.push(d.code);
            }
          });
        }
        var discountParam = remaining.length > 0 ? remaining.join(',') : '';
        
        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          data: { discount: discountParam },
          dataType: 'json',
          success: function(cart) {
          var isCartPage = $('[data-cart-wrapper]').length > 0;
          var responseElement = document.getElementById("DiscountCodeWrapperResponse");
          var responseElementSidecart = document.getElementById("DiscountCodeWrapperResponseSidecart");
          if (responseElement) {
            responseElement.innerHTML = '';
            responseElement.removeAttribute("class");
            responseElement.style.display = "none";
          }
          if (responseElementSidecart) {
            responseElementSidecart.innerHTML = '';
            responseElementSidecart.removeAttribute("class");
            responseElementSidecart.style.display = "none";
          }

          // Sécurité UI : on vide immédiatement les badges de réduction ligne produit.
          // (cart + drawer) pour éviter les "restes" quand les keys/refs DOM changent.
          try {
            $('[data-item-discount-list]').each(function() {
              $(this).html('');
            });
          } catch (e) {}

          // Mettre à jour l'affichage avec le panier renvoyé par l'API (pas de second appel)
          if (isCartPage && typeof cartPageUpdate === 'function') {
            cartPageUpdate(cart);

            // Sécurité UI : sur mobile, il peut arriver que les éléments "discount line"
            // ne soient pas recalculés correctement. Si le serveur ne renvoie plus de discounts
            // par ligne, on vide explicitement les badges.
            try {
              var hasAnyItemDiscounts =
                cart &&
                cart.items &&
                cart.items.some(function(ci) {
                  return ci && ci.discounts && ci.discounts.length > 0;
                });

              if (!hasAnyItemDiscounts) {
                $('[data-item-discount-list]').each(function() {
                  $(this).html('');
                });
              }
            } catch (e) {}
          } else {
            displayAppliedDiscountCodes(cart);
            if (typeof buildCart === 'function') buildCart(cart, false);
            if (typeof freeShippingBar === 'function') freeShippingBar(cart);
          }
        },
        error: function(xhr, status, error) {
          var errorMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.removeError) 
            ? discountCodeMessages.removeError 
            : 'Erreur lors du retrait du code promo.';
          var responseElement = document.getElementById("DiscountCodeWrapperResponse");
          var responseElementSidecart = document.getElementById("DiscountCodeWrapperResponseSidecart");
          if (responseElement) {
            responseElement.innerHTML = '<p class="error-text">' + errorMsg + '</p>';
            responseElement.className = "col-12 form-group error";
            responseElement.style.display = "block";
          }
          if (responseElementSidecart) {
            responseElementSidecart.innerHTML = '<p class="error-text">' + errorMsg + '</p>';
            responseElementSidecart.className = "col-12 form-group error";
            responseElementSidecart.style.display = "block";
          }
        }
        });
      });
    }
    
    // Fonction wrapper pour applyDiscountCode avec callback (plusieurs codes : envoi code1,code2,...)
    function applyDiscountCodeWithCallback(code, callback) {
      var userCode = code.trim();
      
      if (!userCode) {
        var invalidMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.invalid) 
          ? discountCodeMessages.invalid 
          : 'Code promo invalide ou expiré.';
        callback(false, invalidMsg);
        return;
      }
      
      // Récupérer le panier actuel pour conserver les codes déjà appliqués, puis ajouter le nouveau
      $.getJSON(cartUrl, function(currentCart) {
        var existingCodes = [];
        if (currentCart.discount_codes) {
          currentCart.discount_codes.forEach(function(d) {
            if (d.applicable === true && d.code) {
              existingCodes.push(d.code);
            }
          });
        }
        var alreadyThere = existingCodes.some(function(c) { return c.toLowerCase() === userCode.toLowerCase(); });
        if (alreadyThere) {
          var alreadyAppliedMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.alreadyApplied) 
            ? discountCodeMessages.alreadyApplied.replace('{code}', userCode)
            : 'Ce code est déjà appliqué.';
          callback(false, alreadyAppliedMsg);
          return;
        }
        var allCodes = existingCodes.concat([userCode]);
        var discountParam = allCodes.join(',');
        
        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          data: { discount: discountParam },
          dataType: 'json',
          success: function(cart) {
          
          // Vérifier si le code saisi est bien parmi les codes appliqués (plusieurs codes possibles)
          var codeMatches = cart.discount_codes && cart.discount_codes.some(function(d) {
            return d.applicable === true && d.code && d.code.toLowerCase() === userCode.toLowerCase();
          });
          var hasDiscountApplication = cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;
          
          if (codeMatches || hasDiscountApplication) {
            var successMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.success) 
              ? discountCodeMessages.success 
              : 'Code promo appliqué avec succès !';
            callback(true, successMsg);
          } else {
            var oneApplied = cart.discount_codes && cart.discount_codes.find(function(d) { return d.applicable === true; });
            if (oneApplied) {
              var alreadyAppliedMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.alreadyApplied) 
                ? discountCodeMessages.alreadyApplied.replace('{code}', oneApplied.code)
                : 'Un autre code promo (' + oneApplied.code + ') est déjà appliqué. Veuillez le retirer d\'abord.';
              callback(false, alreadyAppliedMsg);
            } else {
              const codePresent = cart.discount_codes && cart.discount_codes.some(
                discount => discount.code.toLowerCase() === userCode.toLowerCase()
              );
              
              if (codePresent) {
                // Code reconnu mais non applicable (ex. produit requis absent) : si lié à un produit (metaobject), ajouter le produit au panier puis réappliquer le code
                var codeKey = userCode.toUpperCase();
                var promoEntry = (typeof window.promoProductByCode !== 'undefined' && window.promoProductByCode[codeKey]) ? window.promoProductByCode[codeKey] : null;
                var notApplicableMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.notApplicable) 
                  ? discountCodeMessages.notApplicable 
                  : 'Ce code promo n\'est pas applicable à votre panier.';
                var successMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.success) 
                  ? discountCodeMessages.success 
                  : 'Code promo appliqué avec succès !';
                if (promoEntry && promoEntry.product_id && promoEntry.variant_id && $('[data-cart-wrapper]').length > 0) {
                  $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    data: { id: promoEntry.variant_id, quantity: 1 },
                    dataType: 'json',
                    success: function() {
                      $.ajax({
                        url: '/cart/update.js',
                        type: 'POST',
                        data: { discount: discountParam },
                        dataType: 'json',
                        success: function(cart2) {
                          var actuallyApplied = null;
                          if (cart2.discount_codes) {
                            cart2.discount_codes.forEach(function(d) {
                              if (d.applicable === true) actuallyApplied = d.code;
                            });
                          }
                          var applied = actuallyApplied && actuallyApplied.toLowerCase() === userCode.toLowerCase();
                          callback(applied, applied ? successMsg : notApplicableMsg);
                        },
                        error: function() {
                          callback(false, notApplicableMsg);
                        }
                      });
                    },
                    error: function(xhr) {
                      var msg = (xhr.responseJSON && xhr.responseJSON.description) ? xhr.responseJSON.description : 'Impossible d\'ajouter le produit.';
                      callback(false, msg);
                    }
                  });
                  return;
                }
                callback(false, notApplicableMsg);
              } else {
                var invalidMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.invalid) 
                  ? discountCodeMessages.invalid 
                  : 'Code promo invalide ou expiré.';
                callback(false, invalidMsg);
              }
            }
          }
        },
        error: function(xhr, status, error) {
          
          // Même en cas d'erreur, vérifier le panier pour voir si le code a été appliqué
          setTimeout(function() {
            jQuery.getJSON(cartUrl, function(cart) {
              var codeMatches = cart.discount_codes && cart.discount_codes.some(function(d) {
                return d.applicable === true && d.code && d.code.toLowerCase() === userCode.toLowerCase();
              });
              var hasDiscountApplication = cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;
              
              if (codeMatches || hasDiscountApplication) {
                var successMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.success) 
                  ? discountCodeMessages.success 
                  : 'Code promo appliqué avec succès !';
                callback(true, successMsg);
              } else {
                var errorMsg = (typeof discountCodeMessages !== 'undefined' && discountCodeMessages.error) 
                  ? discountCodeMessages.error 
                  : 'Erreur lors de l\'application du code promo.';
                callback(false, errorMsg);
              }
            });
          }, 500);
        }
      });
      }); // fin getJSON(currentCart)
    }

    // Initialiser les listeners
    setTimeout(function() {
      setupDiscountCodeListeners();
      // Afficher les codes appliqués au chargement
      jQuery.getJSON(cartUrl, function(cart) {
        displayAppliedDiscountCodes(cart);
      });
    }, 500);

      // Réinitialiser les listeners après chaque mise à jour du panier
      $(document).on('cart:updated', function() {
        setTimeout(function() {
          setupDiscountCodeListeners();
          // Afficher les codes appliqués après mise à jour
          jQuery.getJSON(cartUrl, function(cart) {
            displayAppliedDiscountCodes(cart);
            // Mettre à jour le total dans le drawer si nécessaire
            const drawerBody = $("[data-drawer-body]");
            if (drawerBody.length > 0 && typeof updateCartTotalOnly === 'function') {
              // Mettre à jour uniquement le total
              updateCartTotalOnly(cart);
            }
            
            // Gérer les produits d'ajout rapide après mise à jour du panier
            // Vérifier si on est sur la page panier
            const isCartPage = $('[data-cart-wrapper]').length > 0;
            if (typeof manageQuickAddProducts === 'function') {
              manageQuickAddProducts(cart);
            }
            // Réafficher le quick-add dans le drawer si l'utilisateur a retiré le produit du panier
            if (typeof resetQuickAddDrawerUIWhenProductRemoved === 'function') {
              resetQuickAddDrawerUIWhenProductRemoved(cart);
            }
          });
        }, 300);
      });
      
      // MutationObserver pour synchroniser l'affichage avec l'état réel du panier
      // Flag pour éviter les boucles infinies
      let isSyncingCart = false;
      let cartSyncTimeout = null;
      let isAddingToCart = false; // Flag pour éviter la synchronisation pendant l'ajout
      
      function syncCartWithDOM() {
        if (isSyncingCart || (typeof window.isAddingToCart !== 'undefined' && window.isAddingToCart)) {
          return;
        }
        
        // Vérifier si on est sur la page panier ou dans le drawer
        const isCartPage = $('[data-cart-wrapper]').length > 0;
        const hasDrawer = $("[data-drawer-body]").length > 0;
        
        if (!isCartPage && !hasDrawer) {
          return;
        }
        
        // Compter uniquement les items visibles et valides dans le conteneur de produits
        // Éviter de compter les items en cours de retrait (fadeOut) ou dupliqués
        let domItemsCount = 0;
        
        if (isCartPage) {
          // Sur la page panier, compter uniquement dans [data-cart-products-container]
          const productsContainer = $('[data-cart-wrapper] [data-cart-products-container]');
          if (productsContainer.length > 0) {
            // Compter uniquement les tr ou .media-link visibles avec data-line valide
            domItemsCount = productsContainer.find('tr[data-line], .media-link[data-line]')
              .filter(function() {
                const $item = $(this);
                // Ignorer les items en cours de retrait (fadeOut) ou cachés
                return $item.is(':visible') && !$item.hasClass('cart-item-loading') && $item.css('opacity') !== '0';
              })
              .length;
          }
        } else if (hasDrawer) {
          // Dans le drawer, compter uniquement dans [data-cart-products-container]
          const productsContainer = $('[data-drawer-body] [data-cart-products-container]');
          if (productsContainer.length > 0) {
            domItemsCount = productsContainer.find('tr[data-line], .media-link[data-line]')
              .filter(function() {
                const $item = $(this);
                return $item.is(':visible') && !$item.hasClass('cart-item-loading') && $item.css('opacity') !== '0';
              })
              .length;
          }
        }
        
        // Récupérer le panier depuis le serveur
        jQuery.getJSON(cartUrl, function(serverCart) {
          if (isSyncingCart) {
            return;
          }
          
          // Comparer le nombre d'items (avec une tolérance de ±1 pour éviter les faux positifs)
          const difference = Math.abs(domItemsCount - serverCart.item_count);
          if (difference > 1) { 
            isSyncingCart = true;
            
            // Mettre à jour l'affichage
            if (isCartPage) {
              // Sur la page panier, utiliser updateCartProductsOnly si disponible
              if (typeof updateCartProductsOnly === 'function') {
                updateCartProductsOnly(serverCart);
              } else if (typeof cartPageUpdate === 'function') {
                cartPageUpdate(serverCart);
              }
            } else if (hasDrawer) {
              // Dans le drawer, utiliser updateCartProductsOnly
              if (typeof updateCartProductsOnly === 'function') {
                updateCartProductsOnly(serverCart);
              } else if (typeof buildCart === 'function') {
                buildCart(serverCart, false);
              }
            }
            
            // Réactiver après un délai plus long pour éviter les boucles
            setTimeout(function() {
              isSyncingCart = false;
            }, 2000);
          }
        });
      }
      
      // Observer les changements dans le conteneur du panier
      if (typeof MutationObserver !== 'undefined') {
        const cartSyncObserver = new MutationObserver(function(mutations) {
          // Filtrer les mutations pour ignorer les changements mineurs (styles, classes sur icônes, etc.)
          const significantMutations = mutations.filter(function(mutation) {
            // Ignorer les changements d'attributs (comme style, class sur des éléments non critiques)
            if (mutation.type === 'attributes') {
              // Ignorer les changements sur les icônes SVG et autres éléments décoratifs
              const target = mutation.target;
              if (target && (
                target.tagName === 'svg' || 
                target.tagName === 'path' || 
                target.closest('svg') ||
                target.classList.contains('cart-quick-add-icon') ||
                target.classList.contains('tier-marker-circle') ||
                target.classList.contains('tier-icon-svg-load')
              )) {
                return false;
              }
              // Ignorer les changements de classes qui ne sont pas critiques
              if (mutation.attributeName === 'class') {
                const classList = target.classList;
                // Ignorer les changements de classes liés aux animations/transitions
                if (classList.contains('cart-item-loading') || 
                    classList.contains('loading') ||
                    classList.contains('fadeOut') ||
                    classList.contains('fadeIn')) {
                  return false;
                }
              }
              return false; // Ignorer tous les changements d'attributs pour éviter le scintillement
            }
            
            // Ne garder que les changements de structure (ajout/suppression d'éléments)
            if (mutation.type === 'childList') {
              // Vérifier si c'est un changement significatif (ajout/suppression de lignes produits)
              const addedNodes = Array.from(mutation.addedNodes);
              const removedNodes = Array.from(mutation.removedNodes);
              
              // Si on ajoute ou retire des éléments avec data-line, c'est significatif
              const hasSignificantChange = addedNodes.some(function(node) {
                return node.nodeType === 1 && (
                  node.hasAttribute('data-line') || 
                  node.querySelector && node.querySelector('[data-line]')
                );
              }) || removedNodes.some(function(node) {
                return node.nodeType === 1 && (
                  node.hasAttribute('data-line') || 
                  node.querySelector && node.querySelector('[data-line]')
                );
              });
              
              return hasSignificantChange;
            }
            
            return false;
          });
          
          // Ne déclencher la synchronisation que s'il y a des changements significatifs
          if (significantMutations.length > 0) {
            // Debounce pour éviter trop d'appels
            clearTimeout(cartSyncTimeout);
            cartSyncTimeout = setTimeout(function() {
              if (!isSyncingCart && !(typeof window.isAddingToCart !== 'undefined' && window.isAddingToCart)) {
                syncCartWithDOM();
              }
            }, 2000); // Augmenter le délai à 2 secondes pour réduire la fréquence
          }
        });
        
        // Observer les changements dans le conteneur du panier
        $(document).ready(function() {
          // Observer uniquement le conteneur des produits (plus spécifique)
          const productsContainer = document.querySelector('[data-cart-products-container]');
          if (productsContainer) {
            cartSyncObserver.observe(productsContainer, {
              childList: true,
              subtree: false, // Ne pas observer les sous-éléments pour éviter les changements mineurs
              attributes: false
            });
          }
          
          // Observer aussi le conteneur principal mais avec subtree: false pour éviter les changements sur les icônes
          const cartWrapper = document.querySelector('[data-cart-wrapper]');
          if (cartWrapper) {
            cartSyncObserver.observe(cartWrapper, {
              childList: true,
              subtree: false, // Ne pas observer les sous-éléments
              attributes: false
            });
          }
          
          // Observer le drawer mais sans subtree pour éviter les changements sur les icônes
          const drawerBody = document.querySelector('[data-drawer-body]');
          if (drawerBody) {
            cartSyncObserver.observe(drawerBody, {
              childList: true,
              subtree: false, // Ne pas observer les sous-éléments
              attributes: false
            });
          }
        });
      }
  })();

  // Update quantity based on input on change

  changeCartItem = function (line, quantity) {
    // Récupérer le key de l'item depuis le DOM si disponible (plus fiable après rechargement)
    let itemKey = null;
    const $itemRow = $('[data-line="' + line + '"]').closest('tr[data-cart-item], div[data-cart-item]');
    if ($itemRow.length > 0) {
      itemKey = $itemRow.attr('data-cart-item-key');
    }
    
    // Si on a un key, trouver le line actuel dans le panier frais
    if (itemKey) {
      jQuery.getJSON(cartUrl, function(freshCart) {
        const item = freshCart.items.find(cartItem => cartItem.key === itemKey);
        if (item) {
          // Utiliser le line actuel basé sur le key
          const currentLine = freshCart.items.indexOf(item) + 1;
          changeCartItemByKey(itemKey, currentLine, quantity);
        } else {
          // Si l'item n'existe plus, utiliser le line original
          proceedWithCartChange(line, quantity);
        }
      });
      return;
    }
    
    // Si pas de key, procéder avec le line original (fallback)
    changeCartItemByKey(null, line, quantity);
  };
  
  // Fonction helper pour gérer le changement de quantité avec key
  function changeCartItemByKey(itemKey, line, quantity) {
    // Si on supprime un produit (quantity = 0), vérifier si on passe sous le palier
    if (quantity === 0) {
      jQuery.getJSON(cartUrl, function(currentCart) {
        const item = currentCart.items[line - 1];
        if (!item) {
          // Si l'item n'existe pas, procéder normalement
          proceedWithCartChange(line, quantity);
          return;
        }
        
        // Vérifier si l'article à supprimer est un produit offert
        const isGiftProduct = currentCart.items.some(cartItem => 
          cartItem.key === item.key && 
          (tier1ProductId > 0 && cartItem.product_id === tier1ProductId ||
           tier2ProductId > 0 && cartItem.product_id === tier2ProductId ||
           tier3ProductId > 0 && cartItem.product_id === tier3ProductId)
        );
        
        // Si ce n'est pas un produit offert, vérifier si on passe sous le palier
        if (!isGiftProduct) {
          // Calculer le prix du panier après suppression
          const priceAfterRemoval = currentCart.total_price - (item.final_line_price || item.line_price || 0);
          
          // Vérifier si on passe sous un palier
          let shouldRemoveGiftsFirst = false;
          const giftProductsToRemove = [];
          
          // Vérifier chaque palier
          if (tier1Enabled && tier1Amount > 0 && tier1ProductId > 0) {
            const wasReached = currentCart.total_price >= tier1Amount;
            const willBeReached = priceAfterRemoval >= tier1Amount;
            if (wasReached && !willBeReached) {
              const giftItem = currentCart.items.find(cartItem => cartItem.product_id === tier1ProductId);
              if (giftItem) {
                shouldRemoveGiftsFirst = true;
                giftProductsToRemove.push(giftItem);
              }
            }
          }
          
          if (tier2Enabled && tier2Amount > 0 && tier2ProductId > 0) {
            const wasReached = currentCart.total_price >= tier2Amount;
            const willBeReached = priceAfterRemoval >= tier2Amount;
            if (wasReached && !willBeReached) {
              const giftItem = currentCart.items.find(cartItem => cartItem.product_id === tier2ProductId);
              if (giftItem && !giftProductsToRemove.find(g => g.key === giftItem.key)) {
                shouldRemoveGiftsFirst = true;
                giftProductsToRemove.push(giftItem);
              }
            }
          }
          
          if (tier3Enabled && tier3Amount > 0 && tier3ProductId > 0) {
            const wasReached = currentCart.total_price >= tier3Amount;
            const willBeReached = priceAfterRemoval >= tier3Amount;
            if (wasReached && !willBeReached) {
              const giftItem = currentCart.items.find(cartItem => cartItem.product_id === tier3ProductId);
              if (giftItem && !giftProductsToRemove.find(g => g.key === giftItem.key)) {
                shouldRemoveGiftsFirst = true;
                giftProductsToRemove.push(giftItem);
              }
            }
          }
          
          // Si on doit retirer les produits offerts d'abord
          if (shouldRemoveGiftsFirst && giftProductsToRemove.length > 0) {
            // Ajouter un loader sur le conteneur des produits
            const isCartPageRemove = $('[data-cart-wrapper]').length > 0;
            const productsContainerRemove = isCartPageRemove 
              ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
              : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
            if (productsContainerRemove.length > 0) {
              productsContainerRemove.addClass('loading');
            }

            // Empêcher les séquences concurrentes (changement de marché + listeners + double clic, etc.)
            if (isCartMutationInProgress) {
              stopLoadingSafe(productsContainerRemove);
              if (typeof callback === 'function') callback();
              return;
            }
            isCartMutationInProgress = true;

            // Retirer tous les items (produits offerts + produit original) séquentiellement
            // On doit les retirer un par un pour éviter les problèmes d'indices qui changent
            const allItemsToRemove = [...giftProductsToRemove];
            // Ajouter l'item original à la fin de la liste
            allItemsToRemove.push({ key: item.key });

            // Fonction récursive pour retirer les items un par un
            function removeItemsSequentially(itemsToRemove, index, finalCallback) {
              if (index >= itemsToRemove.length) {
                // Tous les items ont été retirés
                if (typeof finalCallback === 'function') {
                  finalCallback();
                }
                return;
              }

              const itemToRemove = itemsToRemove[index];

              // Récupérer le panier frais pour avoir le bon line number
              jQuery.getJSON(cartUrl, function (freshCart) {
                // Trouver l'item par son key (plus fiable que l'index)
                const item = freshCart.items.find(cartItem => cartItem.key === itemToRemove.key);

                if (!item) {
                  // L'item n'existe plus, passer au suivant
                  removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
                  return;
                }

                // Trouver le line number actuel
                const line = freshCart.items.indexOf(item) + 1;

                if (line > 0) {
                  // Retirer l'item
                  $.ajax({
                    url: cartChangeUrl,
                    type: 'POST',
                    data: 'quantity=0&line=' + line,
                    dataType: 'json'
                  })
                    .always(function () {
                      // Passer au suivant (pas de setTimeout nécessaire ici : on s'appuie sur le callback ajax)
                      removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
                    });
                } else {
                  // Line number invalide, passer au suivant
                  removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
                }
              }).fail(function () {
                // Si on ne peut pas lire le panier, on tente quand même de continuer la séquence
                removeItemsSequentially(itemsToRemove, index + 1, finalCallback);
              });
            }

            // Démarrer le retrait séquentiel
            removeItemsSequentially(allItemsToRemove, 0, function () {
              // Tous les items ont été retirés, mettre à jour l'affichage
              jQuery.getJSON(cartUrl, function (finalCart) {
                // Mettre à jour le prix
                lastCartPrice = finalCart.total_price;

                // Mettre à jour le drawer
                if (typeof buildCart === 'function') {
                  buildCart(finalCart, false);
                }

                // Mettre à jour la page panier si on est sur la page panier
                const isCartPage = $('[data-cart-wrapper]').length > 0;
                if (isCartPage) {
                  // Source de vérité : re-render complet de la page panier
                  if (typeof cartPageUpdate === 'function') {
                    cartPageUpdate(finalCart);
                  } else {
                    // Fallback minimal si cartPageUpdate n'existe pas
                    const $totalPrice = getCartTotalPriceElements();
                    if ($totalPrice.length > 0) {
                      $totalPrice.text(Shopify.formatMoney(finalCart.total_price, moneyFormat));
                    }

                    syncCartOriginalTotalDisplay(finalCart, moneyFormat);

                    // En dernier recours, retirer les rows obsolètes (key-based)
                    const finalKeys = finalCart.items.map(function(i) { return i.key; });
                    const keysToRemove = [];
                    $('[data-cart-item][data-cart-item-key]').each(function() {
                      const key = $(this).attr('data-cart-item-key');
                      if (key && !finalKeys.includes(key)) keysToRemove.push(key);
                    });
                    removeCartRowsByKeys(keysToRemove);
                  }
                }

                // Déverrouiller avant de notifier (sinon certains listeners repartent en boucle)
                isCartMutationInProgress = false;

                // Déclencher l'événement cart:updated UNE SEULE FOIS, après la fin de la séquence
                try {
                  document.dispatchEvent(new CustomEvent('cart:updated'));
                } catch (e) {
                  // noop
                }

                // Retirer le loader (garanti)
                stopLoadingSafe(productsContainerRemove);

                // Appeler le callback
                if (typeof callback === 'function') {
                  callback();
                }
              }).fail(function () {
                // Même si le refresh échoue, on sort du loader et on déverrouille
                isCartMutationInProgress = false;
                stopLoadingSafe(productsContainerRemove);
                if (typeof callback === 'function') {
                  callback();
                }
              });
            });

            return; // Sortir ici, la suppression se fera via AJAX
          }

        }
        
        // Si pas de problème, procéder normalement
        proceedWithCartChange(line, quantity);
      });
      return;
    }
    
    // Si ce n'est pas une suppression, vérifier la limite cadeau puis procéder
    if (quantity > 0) {
      jQuery.getJSON(cartUrl, function (currentCart) {
        const item = itemKey
          ? currentCart.items.find(function (cartItem) {
              return cartItem.key === itemKey;
            })
          : currentCart.items[line - 1];

        if (item && isTierGiftProductId(item.product_id) && quantity > 1) {
          quantity = 1;
        }

        proceedWithCartChange(line, quantity);
      });
      return;
    }

    proceedWithCartChange(line, quantity);
  };
  
  // Fonction helper pour effectuer la suppression/mise à jour
  function proceedWithCartChange(line, quantity, callback) {
    // Ajouter un loader sur le conteneur des produits si on supprime un produit (quantity = 0)
    if (quantity === 0) {
      const isCartPage = $('[data-cart-wrapper]').length > 0;
      const hasDrawerBody = $("[data-drawer-body]").length > 0;
      const isDrawerOpen = hasDrawerBody && $("[data-drawer-body]").is(':visible');
      const isOnCartPage = window.location.pathname.includes('/cart') || window.location.pathname.includes('/panier') || (isCartPage && !isDrawerOpen);
      
      const productsContainer = isOnCartPage 
        ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
        : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
      if (productsContainer.length > 0) {
        productsContainer.addClass('loading');
      }
    }
    
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        // if (quantity == 0) {
        //     $('[name="updates[]"][data-line="' + line + '"]').closest('tr').remove();
        // }
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          // $('[data-cart-form]').hide();
          // $('[data-cart-empty]').show();
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          $("[data-cart-count]").show();

          var item = cart.items[line - 1];
          if (item) {
            // Utiliser data-cart-item-key pour trouver l'élément (plus fiable après rechargement)
            const $itemRow = $('[data-cart-item-key="' + item.key + '"]');
            if ($itemRow.length > 0) {
              $itemRow.find('[name="updates[]"]').val(item.quantity);
            } else {
              // Fallback sur data-line si data-cart-item-key n'est pas disponible
              $('[name="updates[]"][data-line="' + line + '"]').val(item.quantity);
            }
          }
        }
        // Retirer le loader de l'item après la mise à jour
        if (cart.items && cart.items.length > 0 && cart.items[line - 1]) {
          const item = cart.items[line - 1];
          // Utiliser data-cart-item-key pour trouver l'élément (plus fiable après rechargement)
          const $itemRow = $('[data-cart-item-key="' + item.key + '"]');
          if ($itemRow.length > 0) {
            $itemRow.removeClass("cart-item-loading");
          } else {
            // Fallback sur data-line si data-cart-item-key n'est pas disponible
            $('[data-line="' + line + '"]').closest("tr, .media-link").removeClass("cart-item-loading");
          }
        } else {
          // Fallback si l'item n'existe plus
          $('[data-line="' + line + '"]').closest("tr, .media-link").removeClass("cart-item-loading");
        }
        
        // Détecter si on est sur la page panier : vérifier l'URL ou si on a [data-cart-wrapper] sans drawer actif
        const isCartPageUrl = window.location.pathname.includes('/cart') || window.location.pathname.includes('/panier');
        const hasCartWrapper = $("[data-cart-wrapper]").length > 0;
        const hasDrawerBody = $("[data-drawer-body]").length > 0;
        const isDrawerOpen = hasDrawerBody && $("[data-drawer-body]").is(':visible');
        // On est sur la page panier si on a l'URL cart OU si on a le wrapper sans drawer ouvert
        const isCartPage = isCartPageUrl || (hasCartWrapper && !isDrawerOpen);
        
        // Si la quantité est 0, retirer la ligne produit du DOM
        if (quantity === 0) {
          const productsContainerLoader = isCartPage 
            ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
            : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
          
          // Récupérer le panier frais pour obtenir les keys actuelles
          jQuery.getJSON(cartUrl, function(freshCart) {
            // Retirer toutes les lignes qui ne correspondent plus à un item du panier (key-based)
            const finalKeys = freshCart.items.map(function(i) { return i.key; });
            const keysToRemove = [];
            $('[data-cart-item][data-cart-item-key]').each(function() {
              const key = $(this).attr('data-cart-item-key');
              if (key && !finalKeys.includes(key)) {
                keysToRemove.push(key);
              }
            });
            removeCartRowsByKeys(keysToRemove);
            
            // Retirer le loader après la suppression
            stopLoadingSafe(productsContainerLoader);
          }).fail(function() {
            // Même si le refresh échoue, on sort du loader
            stopLoadingSafe(productsContainerLoader);
          });
        }
        
        // Si on est sur la page panier, mettre à jour seulement les parties nécessaires
        if (isCartPage) {
          // Si le panier est vide, recharger complètement la page
          if (cart.item_count === 0) {
            if (typeof cartPageUpdate === 'function') {
              cartPageUpdate(cart);
            }
          } else {
            
            // Mettre à jour le prix total du panier
            const $totalPrice = getCartTotalPriceElements();
            if ($totalPrice.length > 0) {
              $totalPrice.text(Shopify.formatMoney(cart.total_price, moneyFormat));
            }
            
            syncCartOriginalTotalDisplay(cart, moneyFormat);

            // Mettre à jour les prix de tous les produits
            if (cart.items && cart.items.length > 0) {
              cart.items.forEach(function(cartItem, index) {
                const itemLine = index + 1;
                // Utiliser data-cart-item-key pour trouver l'élément (plus fiable après rechargement)
                let $itemRow = $('[data-cart-item-key="' + cartItem.key + '"]');
                if ($itemRow.length === 0) {
                  // Fallback sur data-line si data-cart-item-key n'est pas disponible
                  $itemRow = $('[data-line="' + itemLine + '"]').closest('tr, .media-link');
                }
                // Trouver tous les yv-prizebox pour cet item
                const priceBoxes = $itemRow.find('.yv-prizebox');
                
                priceBoxes.each(function() {
                  const $priceBox = $(this);
                  const $priceSpan = $priceBox.find('.yv-product-price');
                  const $comparePriceSpan = $priceBox.find('.yv-product-compare-price');
                  
                  // Mettre à jour le prix final (final_line_price)
                  if ($priceSpan.length > 0) {
                    const newPrice = cartItem.final_line_price === 0 ? 
                      ($priceSpan.text().includes('Free') ? $priceSpan.text() : 'Free') : 
                      Shopify.formatMoney(cartItem.final_line_price, moneyFormat);
                    $priceSpan.text(newPrice);
                  }
                  
                  // Mettre à jour le prix comparé (original_line_price) si différent
                  if (cartItem.original_line_price !== cartItem.final_line_price) {
                    if ($comparePriceSpan.length === 0) {
                      // Créer le span de prix comparé s'il n'existe pas
                      $priceBox.append('<span class="yv-product-compare-price"></span>');
                    }
                    const comparePrice = Shopify.formatMoney(cartItem.original_line_price, moneyFormat);
                    $priceBox.find('.yv-product-compare-price').text(comparePrice);
                  } else {
                    // Retirer le prix comparé s'il n'est plus nécessaire
                    $comparePriceSpan.remove();
                  }
                });
              });
            }
            
            // Déclencher l'événement cart:updated pour que manageQuickAddProducts soit appelé
            // Cela permettra de retirer les produits d'ajout rapide si nécessaire
            if (!isCartMutationInProgress) {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }
          }
        } else if (isCartPage && cart.items && cart.items.length > 0) {
          // Fallback : mettre à jour manuellement les prix si cartPageUpdate n'existe pas
          // Mettre à jour les prix de tous les produits
          cart.items.forEach(function(cartItem, index) {
            const itemLine = index + 1;
            // Trouver tous les yv-prizebox pour cet item
            const priceBoxes = $('[data-line="' + itemLine + '"]').closest('tr, .media-link').find('.yv-prizebox');
            
            priceBoxes.each(function() {
              const $priceBox = $(this);
              const $priceSpan = $priceBox.find('.yv-product-price');
              const $comparePriceSpan = $priceBox.find('.yv-product-compare-price');
              
              // Mettre à jour le prix final (final_line_price)
              if ($priceSpan.length > 0) {
                const newPrice = cartItem.final_line_price === 0 ? 
                  ($priceSpan.text().includes('Free') ? $priceSpan.text() : 'Free') : 
                  Shopify.formatMoney(cartItem.final_line_price, moneyFormat);
                $priceSpan.text(newPrice);
              }
              
              // Mettre à jour le prix comparé (original_line_price) si différent
              if (cartItem.original_line_price !== cartItem.final_line_price) {
                if ($comparePriceSpan.length === 0) {
                  // Créer le span de prix comparé s'il n'existe pas
                  $priceBox.append('<span class="yv-product-compare-price"></span>');
                }
                const comparePrice = Shopify.formatMoney(cartItem.original_line_price, moneyFormat);
                $priceBox.find('.yv-product-compare-price').text(comparePrice);
              } else {
                // Retirer le prix comparé s'il n'est plus nécessaire
                $comparePriceSpan.remove();
              }
            });
          });
          
          // Mettre à jour le prix total du panier
          const $totalPrice = getCartTotalPriceElements();
          if ($totalPrice.length > 0) {
            $totalPrice.text(Shopify.formatMoney(cart.total_price, moneyFormat));
          }
          
          syncCartOriginalTotalDisplay(cart, moneyFormat);
          
          // Mettre à jour les réductions appliquées (uniquement le récap page panier)
          const $pageSummaryUlDiscounts = $('[data-cart-page-summary]');
          const $totalRowForDiscounts = $pageSummaryUlDiscounts.find('[data-cart-total]').first();
          if ($pageSummaryUlDiscounts.length > 0 && cart.cart_level_discount_applications && $totalRowForDiscounts.length) {
            // Retirer les anciennes réductions
            $pageSummaryUlDiscounts.find('[data-cart-discount]').remove();
            
            // Ajouter les nouvelles réductions
            if (cart.cart_level_discount_applications.length > 0) {
              cart.cart_level_discount_applications.forEach(function(discount) {
                const discountHtml = '<li class="text-medium" data-cart-discount>' +
                  '<span>' + (typeof translations !== 'undefined' && translations.cart ? translations.cart.discount : 'Discount') + '[\'' + discount.title + '\']</span>' +
                  '<strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong>' +
                  '</li>';
                $totalRowForDiscounts.before(discountHtml);
              });
            }
          }
        }
        
        // Mettre à jour le total dans le drawer si on est dans le drawer
        const drawerBody = $("[data-drawer-body]");
        if (drawerBody.length > 0) {
          // Si le panier est vide, recharger complètement le drawer pour afficher l'état vide
          if (cart.item_count === 0) {
            // Recharger complètement le drawer avec l'état vide
            drawerBody.load(mainCartUrl + "?view=jsonData", function () {
              if (typeof initializeCartAfterLoad === 'function') {
                initializeCartAfterLoad(cart, false, null);
              }
            });
          } else {
            // Mettre à jour uniquement le total d'abord (plus rapide)
            if (typeof updateCartTotalOnly === 'function') {
              updateCartTotalOnly(cart);
            }
            // Puis mettre à jour les produits si nécessaire
            if (typeof updateCartProductsOnly === 'function') {
              updateCartProductsOnly(cart);
            }
          }
        }
        
        // Si on est sur la page panier, utiliser cartPageUpdate pour recharger complètement le HTML
        if (isCartPage && typeof cartPageUpdate === 'function') {
          cartPageUpdate(cart);
        }
        // Appeler le callback si fourni
        if (typeof callback === 'function') {
          callback(cart);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          if (quantity == 0) {
            $('[name="updates[]"][data-line="' + line + '"]')
              .closest("tr")
              .remove();
          }
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          if (cart.item_count == 0) {
            // $('[data-cart-form]').hide();
            // $('[data-cart-empty]').show();
            $("[data-cart-count]").hide();
          } else {
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }
          // Retirer le loader de l'item après la mise à jour
          $('[data-line="' + line + '"]').closest("tr").removeClass("cart-item-loading");
          
          // Mettre à jour les prix des produits sur la page panier
          const isCartPage = $("[data-cart-wrapper]").length > 0 && $("[data-drawer-body]").length === 0;
          if (isCartPage && cart.items && cart.items.length > 0) {
            // Mettre à jour les prix de tous les produits
            cart.items.forEach(function(cartItem, index) {
              const itemLine = index + 1;
              // Trouver tous les yv-prizebox pour cet item
              const priceBoxes = $('[data-line="' + itemLine + '"]').closest('tr, .media-link').find('.yv-prizebox');
              
              priceBoxes.each(function() {
                const $priceBox = $(this);
                const $priceSpan = $priceBox.find('.yv-product-price');
                const $comparePriceSpan = $priceBox.find('.yv-product-compare-price');
                
                // Mettre à jour le prix final (final_line_price)
                if ($priceSpan.length > 0) {
                  if (cartItem.final_line_price === 0) {
                    $priceSpan.text($priceSpan.text().includes('Free') ? $priceSpan.text() : 'Free');
                  } else {
                    $priceSpan.text(Shopify.formatMoney(cartItem.final_line_price, moneyFormat));
                  }
                }
                
                // Mettre à jour le prix comparé (original_line_price) si différent
                if (cartItem.original_line_price !== cartItem.final_line_price) {
                  if ($comparePriceSpan.length === 0) {
                    // Créer le span de prix comparé s'il n'existe pas
                    $priceBox.append('<span class="yv-product-compare-price"></span>');
                  }
                  $priceBox.find('.yv-product-compare-price').text(Shopify.formatMoney(cartItem.original_line_price, moneyFormat));
                } else {
                  // Retirer le prix comparé s'il n'est plus nécessaire
                  $comparePriceSpan.remove();
                }
              });
            });
            
            // Mettre à jour le prix total du panier
            const $totalPrice = getCartTotalPriceElements();
            if ($totalPrice.length > 0) {
              $totalPrice.text(Shopify.formatMoney(cart.total_price, moneyFormat));
            }
            
            syncCartOriginalTotalDisplay(cart, moneyFormat);
            
            // Mettre à jour les réductions appliquées (uniquement le récap page panier)
            const $pageSummaryUlDiscountsErr = $('[data-cart-page-summary]');
            const $totalRowForDiscountsErr = $pageSummaryUlDiscountsErr.find('[data-cart-total]').first();
            if ($pageSummaryUlDiscountsErr.length > 0 && cart.cart_level_discount_applications && $totalRowForDiscountsErr.length) {
              // Retirer les anciennes réductions
              $pageSummaryUlDiscountsErr.find('[data-cart-discount]').remove();
              
              // Ajouter les nouvelles réductions
              if (cart.cart_level_discount_applications.length > 0) {
                cart.cart_level_discount_applications.forEach(function(discount) {
                  const discountHtml = '<li class="text-medium" data-cart-discount>' +
                    '<span>' + (typeof translations !== 'undefined' && translations.cart ? translations.cart.discount : 'Discount') + '[\'' + discount.title + '\']</span>' +
                    '<strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong>' +
                    '</li>';
                  $totalRowForDiscountsErr.before(discountHtml);
                });
              }
            }
          }
          
          // Mettre à jour le total dans le drawer si on est dans le drawer
          const drawerBody = $("[data-drawer-body]");
          if (drawerBody.length > 0) {
            // Si le panier est vide, recharger complètement le drawer pour afficher l'état vide
            if (cart.item_count === 0) {
              // Recharger complètement le drawer avec l'état vide
              drawerBody.load(mainCartUrl + "?view=jsonData", function () {
                if (typeof initializeCartAfterLoad === 'function') {
                  initializeCartAfterLoad(cart, false, null);
                }
              });
            } else {
              // Mettre à jour uniquement le total d'abord (plus rapide)
              if (typeof updateCartTotalOnly === 'function') {
                updateCartTotalOnly(cart);
              }
              // Puis mettre à jour les produits si nécessaire
              if (typeof updateCartProductsOnly === 'function') {
                updateCartProductsOnly(cart);
              }
            }
          } else if (!isCartPage) {
            // Si on est sur la page panier, utiliser cartPageUpdate
            cartPageUpdate(cart);
          }
          // Appeler le callback si fourni
          if (typeof callback === 'function') {
            callback(cart);
          }
        });
      },
    };
    jQuery.ajax(params);
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]');

    $("#cartItemError-" + line).html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      // Ajouter un loader uniquement sur l'item modifié pour les ajustements de quantité (pas pour les suppressions)
      if (qty > 0) {
        parent.addClass("cart-item-loading");
      }
      changeCartItem(line, qty);
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, ""));

    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);
    // Add or subtract from the current quantity

    if (line) {
      // Ajouter un loader uniquement sur l'item modifié pour les ajustements de quantité (pas pour les suppressions)
      if (qty > 0) {
        parent.addClass("cart-item-loading");
      }
      changeCartItem(line, qty);
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    // If it has a data-line, update the cart
    if (line) {
      // Ne pas ajouter le loader de ligne pour les suppressions, le loader global sera utilisé
      changeCartItem(line, 0);
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback) {
    var $body = $(document.body),
      params = {
        type: "POST",
        url: cartChangeUrl,
        data: "quantity=" + quantity + "&line=" + line,
        dataType: "json",
        success: function (cart) {
          if (cart.item_count == 0) {
            emptyCartStatus = true;
            $("[data-cart-count]").hide();
          } else {
            emptyCartStatus = false;
            $("[data-cart-count]").show();
          }
          var item = cart.items[line - 1];
          if (item) {
            $(
              '.ajaxcart__qty-num[name="updates[]"][data-line="' + line + '"]'
            ).val(item.quantity);
          }
          callback(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            callback(cart);
          });
        },
      };
    jQuery.ajax(params);
  };

  updateQuantity = function (line, qty, callback) {
    isUpdating = true;
    setTimeout(function () {
      changeItem(line, qty, callback);
    }, 250);
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }
  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  // Ajout au panier : toujours actif (page panier upsell, fiches produit, drawer si activé)
  $("body").on("click", ".Sd_addProduct", function (evt) {
    evt.preventDefault();

    let submit = $(this);
    let form = $(this).closest("form");
    if (submit.hasClass("Sd_addProductSticky")) {
      form = jQuery("#" + submit.attr("form"));
    }
    if (form.length === 0) return;
    if (form.attr("data-purchase-blocked") === "true") {
      submit.removeClass("is-loading");
      return;
    }
    var idInput = form.find('input[name="id"]');
    var variantIdRaw = idInput.length ? idInput.val() : null;
    var variantId = (variantIdRaw != null && String(variantIdRaw).trim() !== "") ? String(variantIdRaw).trim() : null;
    if (!variantId) {
      submit.removeClass("is-loading");
      return;
    }
    if (form.closest(".yv_side_drawer_wrapper").length == 0) {
      focusElement = submit;
    }
    let parentSection = form.closest(".shopify-section");
    var Email = $('input[data-attr="' + "email" + '"]').val();
    $('input[data-attr="' + "email" + '"]').val("");
    $('input[data-attr="' + "name" + '"]').val("");
    if (parentSection.length > 0) parentSection.find(".productErrors").hide().html("");
    submit.addClass("is-loading");
    
    const isCartPageAdd = window.location.pathname.indexOf("/cart") > -1 || window.location.pathname.indexOf("/panier") > -1;
    const productsContainerAdd = isCartPageAdd 
      ? $('[data-cart-wrapper] .yv-cart-table')
      : $('[data-drawer-body] [data-cart-products-container]');
    if (productsContainerAdd.length > 0) {
      productsContainerAdd.addClass('loading');
    }
    
    var isCartPageClick = window.location.pathname.indexOf("/cart") > -1 || window.location.pathname.indexOf("/panier") > -1;
    if (cartDrawerEnable && form.closest(".yv_side_drawer_wrapper").length == 0 && !isCartPageClick) {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").find("[data-side-drawer]").attr("id", "mini__cart");
        $("body").find("[data-side-drawer]").addClass("mini_cart");
      }

      // remove empty properties
      form.find('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]').each(function () {
        if ($(this).val().trim() === "") {
          $(this).prop("disabled", true);
        }
      });

      if (window.haProductQuantity && typeof window.haProductQuantity.resolveForm === "function") {
        window.haProductQuantity.resolveForm(form[0]);
      }

      var addUrl = typeof cartAddUrl !== "undefined" ? cartAddUrl : "";
      var inUpsellWrapper = form.closest("[data-cart-upsell-wrapper]").length > 0;
      if (inUpsellWrapper) {
        var root = (typeof window !== "undefined" && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "";
        addUrl = root + "cart/add.js";
      }
      var payload = inUpsellWrapper ? ("id=" + encodeURIComponent(variantId) + "&quantity=1") : form.serialize();

      params = {
        type: "POST",
        url: addUrl,
        data: payload,
        dataType: "json",
        success: function (line_item) {
          try {
            if (line_item == null || typeof line_item !== "object") return;
          } catch (e) { return; }
          try {
          if (form.closest(".yv_side_drawer_wrapper").length > 0) {
            $("[data-drawer-body]").html(preLoadLoadGif);
            $("body")
              .find("[data-side-drawer]")
              .attr("class", "yv_side_drawer_wrapper");
            $("body").find("[data-drawer-title]").html(cartTitleLabel);
            $("body").find("[data-side-drawer]").attr("id", "mini__cart");
            $("body").find("[data-side-drawer]").addClass("mini_cart");
          }

          // Vérifier si on est sur la page panier (cart ou panier)
          var isCartPage = window.location.pathname.indexOf("/cart") > -1 || window.location.pathname.indexOf("/panier") > -1;
          
          if (isCartPage) {
            jQuery.getJSON(cartUrl, function (cart, textStatus) {
              if (typeof cartPageUpdate === 'function') {
                cartPageUpdate(cart);
              }
              setTimeout(function () {
                if (productsContainerAdd.length > 0) {
                  productsContainerAdd.removeClass('loading');
                }
                submit.removeClass("is-loading");
                form.find('[name^="properties["]:disabled').prop("disabled", false);
              }, 300);
            });
          } else if (cartDrawerEnable) {
            $("body").removeClass("quickview-open");
            $("body").addClass("side_Drawer_open");
            jQuery.getJSON(cartUrl, function (cart, textStatus) {
              const drawerBody = $("[data-drawer-body]");
              const productsContainer = $("[data-cart-products-container]");
              if (productsContainer.length > 0 && drawerBody.length > 0 && typeof updateCartProductsOnly === 'function') {
                updateCartProductsOnly(cart);
                setTimeout(function() {
                  if (productsContainerAdd.length > 0) {
                    productsContainerAdd.removeClass('loading');
                  }
                }, 300);
                $("body").addClass("yv_side_Drawer_open");
                $(".wrapper-overlay").css({ display: "block" });
                focusElementsRotation($("[data-side-drawer]"));
                $(document).find(".yv_side_drawer_wrapper").trigger("focus");
              } else {
                buildCart(cart, true);
                setTimeout(function() {
                  if (productsContainerAdd.length > 0) {
                    productsContainerAdd.removeClass('loading');
                  }
                }, 500);
              }
              setTimeout(function () {
                submit.removeClass("is-loading");
                form.find('[name^="properties["]:disabled').prop("disabled", false);
              }, 1000);
            });
          } else {
            setTimeout(function () {
              if (productsContainerAdd.length > 0) {
                productsContainerAdd.removeClass('loading');
              }
              submit.removeClass("is-loading");
              form.find('[name^="properties["]:disabled').prop("disabled", false);
            }, 300);
          }
          } catch (err) {
            submit.removeClass("is-loading");
            if (productsContainerAdd.length > 0) productsContainerAdd.removeClass('loading');
            form.find('[name^="properties["]:disabled').prop("disabled", false);
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          var status = XMLHttpRequest && XMLHttpRequest.status;
          var res = (XMLHttpRequest && XMLHttpRequest.responseJSON) || null;
          if (window.console && console.warn) console.warn("[Cart] Sd_addProduct: erreur cart/add.js", { status: status, responseJSON: res, variantId: variantId, url: addUrl });
          if (productsContainerAdd.length > 0) {
            productsContainerAdd.removeClass('loading');
          }
          submit.removeClass("is-loading");
          form.find('[name^="properties["]:disabled').prop("disabled", false);
          focusElement = "";
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            let errorContainer = parentSection.length > 0 ? parentSection.find(".productErrors") : $();
            if (errorContainer.length > 0) {
              if (res && res.errors) {
                let giftCardWrapper = form.find('[data-gift-card-box]');
                if(giftCardWrapper.length > 0 && (res.errors['email'] || res.errors['send_on'])){
                  if(res.errors['email']){
                    let giftCardEmail = giftCardWrapper.find('[type=email]');
                    errorContainer.html(giftCardEmail.attr('data-attr') + ' ' +  res.errors['email']).show();
                  }else{
                    let giftCardDate = giftCardWrapper.find('input[name="properties[Send on]"]');
                    errorContainer.html(giftCardDate.attr('data-placeholder') + ' ' +  res.errors['send_on'][0].replace("Send on", "")).show();
                  }
                  errorContainer[0].style.setProperty("display", "block", "important");
                }
              } else if (res && res.description) {
                errorContainer.html(res.description).show();
              }
            }
          }
          setTimeout(function () {
            $(".Sd_addProductSticky").removeClass("is-loading");
            submit.removeClass("is-loading");
            form.find('[name^="properties["]:disabled').prop("disabled", false);
          }, 1000);
        },
      };
      jQuery.ajax(params);
  });

  if (cartDrawerEnable) {
    // Update quantity based on input on change
    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        // Créer un callback personnalisé qui met à jour le total
        updateQuantity(line, qty, function(cart) {
          // Mettre à jour le total dans le drawer
          const drawerBody = $("[data-drawer-body]");
          if (drawerBody.length > 0) {
            // Si le panier est vide, recharger complètement le drawer
            if (cart.item_count === 0) {
              // Recharger complètement le drawer avec l'état vide
              drawerBody.load(mainCartUrl + "?view=jsonData", function () {
                if (typeof initializeCartAfterLoad === 'function') {
                  initializeCartAfterLoad(cart, false, null);
                }
              });
            } else {
              // Mettre à jour le total
              if (typeof updateCartTotalOnly === 'function') {
                updateCartTotalOnly(cart);
              }
              // Appeler buildCart pour mettre à jour le reste
              if (typeof buildCart === 'function') {
                buildCart(cart, false);
              }
            }
          }
        });
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        // Créer un callback personnalisé qui met à jour le total
        updateQuantity(line, qty, function(cart) {
          // Mettre à jour le total dans le drawer
          const drawerBody = $("[data-drawer-body]");
          if (drawerBody.length > 0) {
            // Si le panier est vide, recharger complètement le drawer
            if (cart.item_count === 0) {
              // Recharger complètement le drawer avec l'état vide
              drawerBody.load(mainCartUrl + "?view=jsonData", function () {
                if (typeof initializeCartAfterLoad === 'function') {
                  initializeCartAfterLoad(cart, false, null);
                }
              });
            } else {
              // Mettre à jour le total
              if (typeof updateCartTotalOnly === 'function') {
                updateCartTotalOnly(cart);
              }
              // Appeler buildCart pour mettre à jour le reste
              if (typeof buildCart === 'function') {
                buildCart(cart, false);
              }
            }
          }
        });
      }
    });

    function openCartDrawer(element) {
      try {
        const drawerBody = $("[data-drawer-body]");
        const productsContainer = $("[data-cart-products-container]");
        
        // Si le drawer est déjà chargé, mettre à jour uniquement les produits et le total
        if (productsContainer.length > 0 && drawerBody.length > 0) {
          $("body").removeClass("quickview-open");
          $("body").addClass("side_Drawer_open");
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            if (typeof updateCartProductsOnly === 'function') {
              updateCartProductsOnly(cart);
              // Ouvrir le drawer
              $("body").addClass("yv_side_Drawer_open");
              $(".wrapper-overlay").css({ display: "block" });
              focusElementsRotation($("[data-side-drawer]"));
              if (element) {
                focusElement = element;
              }
              $(document).find(".yv_side_drawer_wrapper").trigger("focus");
            } else {
              buildCart(cart, true, element);
            }
          }).fail(function(jqXHR, textStatus, errorThrown) {
            // Erreur silencieuse
          });
        } else {
          // Sinon, charger tout le drawer (premier chargement)
          drawerBody.html(preLoadLoadGif);
          $("body").find("[data-drawer-title]").html(cartTitleLabel);
          $("body")
            .find("[data-side-drawer]")
            .attr("class", "yv_side_drawer_wrapper");
          $("body")
            .find("[data-side-drawer]")
            .attr("id", "mini__cart")
            .addClass("mini_cart");
          $("body").addClass("side_Drawer_open");
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            buildCart(cart, true, element);
          }).fail(function(jqXHR, textStatus, errorThrown) {
            // Erreur silencieuse
          });
        }
      } catch (error) {
        // Erreur silencieuse
      }
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line"));
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, 0, buildCart);
      }
    });

    $(document).on("click", ".cartDrawerNote:not(.cart-quick-add-toggle)", function (evt) {
      $(this).toggleClass("active");
      var textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });
  }
}
// Gérer le clic sur le Gift Wrap (ancien système)
$("body").on("click", "#GiftWrapProduct", function () {
  params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: parseInt($(this).attr("data-product")), quantity: 1 },
    dataType: "json",
    success: function (line_item) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          buildCart(cart, true);
        } else {
          cartPageUpdate(cart);
        }
      });
    },
  };
  jQuery.ajax(params);
});

// Gérer le clic sur le toggle des produits d'ajout rapide (rétractation)
$(document).on("click", ".cart-quick-add-toggle", function (evt) {
  evt.stopPropagation();
  evt.preventDefault();
  $(this).toggleClass("active");
  var content = $(this).siblings(".cart-quick-add-content");
  content.slideToggle();
});

// Popin info livraison (free-shipping card) : toggle au clic, fermeture (popin en sibling du wrapper)
$(document).on("click", "[data-free-shipping-info-btn]", function (evt) {
  evt.preventDefault();
  evt.stopPropagation();
  var wrapper = $(this).closest("[data-free-shipping-info-wrapper]");
  var popin = wrapper.siblings("[data-free-shipping-info-popin]");
  popin.toggleClass("is-visible");
});

$(document).on("click", "[data-free-shipping-info-close]", function (evt) {
  evt.preventDefault();
  evt.stopPropagation();
  $(this).closest("[data-free-shipping-info-popin]").removeClass("is-visible");
});

$(document).on("click", function (evt) {
  var target = $(evt.target);
  if (!target.closest("[data-free-shipping-info-wrapper]").length) {
    $("[data-free-shipping-info-popin].is-visible").removeClass("is-visible");
  }
});

// Gérer le clic sur le bouton d'ajout des produits d'ajout rapide (nouveau système via metaobjects)
$("body").on("click", ".cart-quick-add-btn", function () {
  const button = $(this);
  const variantId = parseInt(button.attr("data-product"));
  const productId = parseInt(button.attr("data-product-id"));
  const productName = button.attr("data-product-name") || '';
  const productPrice = button.attr("data-product-price") || '';
  let addText = button.attr("data-add-text") || '';
  let successText = button.attr("data-success-text") || '';
  const quickAddContainer = button.closest('.cart-quick-add-product');
  const toggleElement = quickAddContainer.find('.cart-quick-add-toggle');
  
  // Remplacer les variables dans les textes
  if (addText) {
    addText = String(addText).replace(/\|\|product\|\|/g, productName);
    addText = String(addText).replace(/\|\|price\|\|/g, productPrice);
  }
  if (successText) {
    successText = String(successText).replace(/\|\|product\|\|/g, productName);
    successText = String(successText).replace(/\|\|price\|\|/g, productPrice);
  }
  
  // Désactiver le bouton pendant l'ajout
  button.prop('disabled', true).addClass('is-loading');
  
  // Ajouter un loader sur le conteneur des produits
  const isCartPage = $('[data-cart-wrapper]').length > 0;
  const productsContainer = isCartPage 
    ? $('[data-cart-wrapper] .yv-cart-table') // Utiliser .yv-cart-table pour la page panier
    : $('[data-drawer-body] [data-cart-products-container]'); // Garder [data-cart-products-container] pour le drawer
  if (productsContainer.length > 0) {
    productsContainer.addClass('loading');
  }
  
  // Marquer qu'on est en train d'ajouter un produit pour éviter la synchronisation
  if (typeof window.isAddingToCart === 'undefined') {
    window.isAddingToCart = false;
  }
  window.isAddingToCart = true;
  
  params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: variantId, quantity: 1 },
    dataType: "json",
    success: function (line_item) {
              // Cacher le contenu rétractable
              quickAddContainer.find('.cart-quick-add-content').slideUp().hide();
              
              // Remplacer le toggle par un message de succès
              if (successText && successText.trim() !== '') {
                const successIcon = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 14px; height: 14px; flex-shrink: 0; transform: rotate(0deg);"><path fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>';
                const successHtml = '<span class="cart-quick-add-success" style="display: inline-flex; align-items: center; gap: 6px; color: var(--colorTextBody, #01033a);">' + successIcon + '<span>' + successText + '</span></span>';
                toggleElement.html(successHtml);
        
        // Retirer la classe de toggle pour désactiver le clic
        toggleElement.removeClass('cart-quick-add-toggle');
        toggleElement.off('click');
      }
      
      // Mettre à jour le localStorage avec le productId du produit qui vient d'être ajouté
      // Cela évite que manageQuickAddProducts ne le supprime juste après
      if (productId && productId > 0) {
        try {
          let storedIds = [];
          const stored = localStorage.getItem('cart_quick_add_product_ids');
          if (stored) {
            storedIds = JSON.parse(stored);
          }
          if (!storedIds.includes(productId)) {
            storedIds.push(productId);
            localStorage.setItem('cart_quick_add_product_ids', JSON.stringify(storedIds));
          }
          
          // Ajouter le produit à la liste des produits récemment ajoutés
          recentlyAddedQuickAddProductIds.push({
            productId: productId,
            timestamp: Date.now()
          });
        } catch (e) {
          // Ignorer les erreurs de localStorage
        }
      }
      
      // Recharger le panier
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          cartPageUpdate(cart);
          // Retirer le loader après la mise à jour
          setTimeout(function() {
            if (productsContainer.length > 0) {
              productsContainer.removeClass('loading');
            }
          }, 300);
        } else {
          // Vérifier si le drawer est déjà chargé
          const drawerBody = $("[data-drawer-body]");
          const drawerProductsContainer = $("[data-drawer-body] [data-cart-products-container]");
          
          if (drawerProductsContainer.length > 0 && drawerBody.length > 0) {
            // Mettre à jour uniquement les produits et le total
            updateCartProductsOnly(cart);
            // Retirer le loader après la mise à jour
            setTimeout(function() {
              if (drawerProductsContainer.length > 0) {
                drawerProductsContainer.removeClass('loading');
              }
            }, 300);
            // Ouvrir le drawer
            $("body").addClass("yv_side_Drawer_open");
            $(".wrapper-overlay").css({ display: "block" });
            focusElementsRotation($("[data-side-drawer]"));
            $(document).find(".yv_side_drawer_wrapper").trigger("focus");
          } else {
            // Sinon, charger tout le drawer (premier chargement)
            buildCart(cart, true);
            // Retirer le loader après le chargement
            setTimeout(function() {
              if (productsContainer.length > 0) {
                productsContainer.removeClass('loading');
              }
            }, 500);
          }
        }
        
        // Réactiver le flag après un délai pour permettre la synchronisation
        setTimeout(function() {
          window.isAddingToCart = false;
        }, 2000);
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      // Réactiver le bouton en cas d'erreur
      button.prop('disabled', false).removeClass('is-loading');
      
      // Retirer le loader en cas d'erreur
      if (productsContainer.length > 0) {
        productsContainer.removeClass('loading');
      }
      
      // Réactiver le flag
      window.isAddingToCart = false;
      
      // Recharger le panier
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          buildCart(cart, true);
        } else {
          cartPageUpdate(cart);
        }
      });
    },
  };
  jQuery.ajax(params);
});

// Fonction pour mettre à jour uniquement le container produits et le total dans le drawer
updateCartProductsOnly = function (cart) {
  // Si le panier est vide, recharger complètement le drawer
  if (cart.item_count === 0) {
    const drawerBody = $("[data-drawer-body]");
    if (drawerBody.length > 0) {
      drawerBody.load(mainCartUrl + "?view=jsonData", function () {
        if (typeof initializeCartAfterLoad === 'function') {
          initializeCartAfterLoad(cart, false, null);
        }
      });
    }
    return;
  }
  
  const productsContainer = $("[data-cart-products-container]");
  // Chercher le bottom-cart-box dans le drawer parent (pas seulement dans le container)
  const drawerBody = $("[data-drawer-body]");
  const bottomCartBox = drawerBody.length > 0 
    ? drawerBody.closest("[data-side-drawer], .yv_side_drawer_wrapper").find(".bottom-cart-box")
    : $(".bottom-cart-box");
  
  if (productsContainer.length > 0) {
    productsContainer.addClass("loading");
    // Charger uniquement la partie produits depuis le template
    $.ajax({
      url: mainCartUrl + "?view=jsonData",
      type: "GET",
      dataType: "html",
      success: function(result) {
        const $result = $(result);
        const newProductsContainer = $result.find("[data-cart-products-container]");
        const newBottomCartBox = $result.find(".bottom-cart-box");
        
        if (newProductsContainer.length > 0) {
          productsContainer.html(newProductsContainer.html());
        }
        
        const $totalPrice = getCartTotalPriceElements();
        if ($totalPrice.length > 0) {
          $totalPrice.text(Shopify.formatMoney(cart.total_price, moneyFormat));
        }
        syncCartOriginalTotalDisplay(cart, moneyFormat);
        
        productsContainer.removeClass("loading");
        
        // Initialiser après la mise à jour
        if (typeof initializeCartAfterUpdate === 'function') {
          initializeCartAfterUpdate(cart);
        } else {
          // Fallback si la fonction n'existe pas encore
          const shippingBarContainer = $("[data-free-shipping-container]");
          if (cart.item_count > 0 && shippingBarContainer.length > 0) {
            shippingBarContainer.removeClass('hidden');
          }
          isUpdatingTiers = false;
          lastCartPrice = cart.total_price;
          setTimeout(function() {
            if (typeof freeShippingBar === 'function') {
              freeShippingBar(cart);
            }
            setTimeout(function() {
              if (typeof manageQuickAddProducts === 'function') {
                manageQuickAddProducts(cart);
              }
            }, 500);
          }, 200);
          if (typeof upsellCartDrawerProducts === 'function') {
            upsellCartDrawerProducts(cart,'drawer');
          }
          if (!isCartMutationInProgress) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        }
        // Réafficher le quick-add dans le drawer si l'utilisateur a retiré le produit du panier
        if (typeof resetQuickAddDrawerUIWhenProductRemoved === 'function') {
          resetQuickAddDrawerUIWhenProductRemoved(cart);
        }
      },
      error: function() {
        productsContainer.removeClass("loading");
        // En cas d'erreur, recharger tout le drawer
        const drawerBody = $("[data-drawer-body]");
        drawerBody.load(mainCartUrl + "?view=jsonData", function () {
          if (typeof initializeCartAfterLoad === 'function') {
            initializeCartAfterLoad(cart, false, null);
          }
        });
      }
    });
  } else {
    // Si le container n'existe pas, recharger tout
    const drawerBody = $("[data-drawer-body]");
    drawerBody.load(mainCartUrl + "?view=jsonData", function () {
      if (typeof initializeCartAfterLoad === 'function') {
        initializeCartAfterLoad(cart, false, null);
      }
    });
  }
};

cartPageUpdate = function (cart) {
  
  // Ajouter un timestamp pour éviter le cache
  const cacheBuster = '?t=' + new Date().getTime();
  const urlWithCacheBuster = mainCartUrl + (mainCartUrl.indexOf('?') > -1 ? '&' : '?') + 't=' + new Date().getTime();
  
  $.ajax({
    url: urlWithCacheBuster,
    type: "GET",
    dataType: "html",
    cache: false,
    success: function (result) {
      const $result = $(result);
      const cartWrapper = $result.find("[data-cart-wrapper]");
      
      if (cartWrapper.length === 0) {
        // Essayer de recharger la page complète si le HTML ne contient pas le wrapper
        if (cart.item_count === 0) {
          window.location.reload();
        }
        return;
      }

      const currentCartWrapper = $("body").find("[data-cart-wrapper]");
      
      if (cartWrapper.length > 0 && currentCartWrapper.length > 0) {
        currentCartWrapper.html(cartWrapper.html());
      } else {
        // Ne pas recharger la page, juste logger l'erreur
        return;
      }
      $(".cart-section").find("a:first").trigger("focus");
      // S'assurer que le container de la progress bar est visible après le chargement
      const shippingBarContainer = $("[data-free-shipping-container]");
      if (cart.item_count > 0 && shippingBarContainer.length > 0) {
        shippingBarContainer.removeClass('hidden');
      }
      // Forcer la réinitialisation du flag pour permettre l'exécution
      isUpdatingTiers = false;
      lastCartPrice = 0; // Forcer la mise à jour
      // Ouvrir le contenu d'ajout rapide par défaut
      $('.cart-quick-add-toggle.active').each(function() {
        $(this).siblings('.cart-quick-add-content').show();
      });
      
      // Attendre un peu pour que le DOM soit complètement mis à jour
      setTimeout(function() {
        freeShippingBar(cart);
        updateTierGiftCartItemUi();
        // Réinitialiser les listeners après la mise à jour
        if (typeof setupDiscountCodeListeners === 'function') {
          setupDiscountCodeListeners();
        }
        // Afficher les codes promo appliqués
        if (typeof displayAppliedDiscountCodes === 'function') {
          displayAppliedDiscountCodes(cart);
        }
        // Gérer les produits d'ajout rapide après le rechargement du DOM
        // Attendre un peu plus pour que le DOM soit complètement chargé
        setTimeout(function() {
          if (typeof manageQuickAddProducts === 'function') {
            manageQuickAddProducts(cart);
          }
        }, 300);
      }, 150);
      upsellCartProducts(cart)
      window.shippingEstimates();
      // Déclencher l'événement cart:updated pour que les listeners soient notifiés
      if (!isCartMutationInProgress) {
  document.dispatchEvent(new CustomEvent('cart:updated'));
}
      // $('body').find('[data-cart-items]').html($(result).find('[data-cart-items]').html());
      // $("body").find("[data-cart-items]").removeClass('disabled');
      // if (cart.item_count == 0) {
      //     emptyCartStatus = true;
      //     $('[data-cart-count').hide();
      //     $('.cart-section').find('a:first').trigger('focus');
      // } else {
      //     emptyCartStatus = false;
      //     $('body').find('[data-cart-items]').find('a:first').trigger('focus');
      // }
      // $('[data-cart-item-count]').text(cart.item_count);
      // $('[data-cart-original-price]').text(Shopify.formatMoney(cart.original_total_price, moneyFormat));
      // $('[data-cart-total-price]').text(Shopify.formatMoney(cart.total_price, moneyFormat));
      // if (cart.cart_level_discount_applications.length > 0) {
      //     var discounts = '';
      //     $.each(cart.cart_level_discount_applications, function(index, discount) {
      //         discounts += '<li data-cart-discount>Discount[' + discount.title + '] <strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong></li>';
      //     })
      //     $('li[data-cart-discount]').remove();
      //     $('li[data-cart-original]').removeClass('hidden');
      //     $(discounts).insertAfter('li[data-cart-original]')
      // } else {
      //     $('li[data-cart-original]').addClass('hidden');
      //     $('li[data-cart-discount]').remove();
      // }
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

// Fonction d'initialisation après mise à jour (sans ouvrir le drawer) - globale
initializeCartAfterUpdate = function (cart) {
  // Ouvrir le contenu d'ajout rapide par défaut
  $('.cart-quick-add-toggle.active').each(function() {
    $(this).siblings('.cart-quick-add-content').show();
  });
  
  // S'assurer que le container de la progress bar est visible
  const shippingBarContainer = $("[data-free-shipping-container]");
  if (cart.item_count > 0 && shippingBarContainer.length > 0) {
    shippingBarContainer.removeClass('hidden');
  }
  // Forcer la réinitialisation du flag pour permettre l'exécution
  isUpdatingTiers = false;
  lastCartPrice = cart.total_price;
  // Attendre un peu pour que le DOM soit complètement chargé
  setTimeout(function() {
    freeShippingBar(cart);
    // Gérer les produits d'ajout rapide après le rechargement du DOM
    setTimeout(function() {
      if (typeof manageQuickAddProducts === 'function') {
        manageQuickAddProducts(cart);
      }
    }, 500);
  }, 200);
  upsellCartDrawerProducts(cart,'drawer')
  if (!isCartMutationInProgress) {
  document.dispatchEvent(new CustomEvent('cart:updated'));
}
};

buildCart = function (cart, showCart, element) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  
  const drawerBody = $("[data-drawer-body]");
  const productsContainer = $("[data-cart-products-container]");
  
  // Fonction d'initialisation après le chargement complet
  function initializeCartAfterLoad(cart, showCart, element) {
    var drawerBodyEl = document.querySelector("[data-drawer-body]");
    if (drawerBodyEl && window.Alpine && typeof window.Alpine.initTree === "function") {
      try {
        window.Alpine.initTree(drawerBodyEl);
      } catch (e) {}
    }
    // Synchroniser les totaux affichés avec l'objet cart (drawer venant d'être rechargé)
    if (cart && cart.item_count > 0) {
      const $totalPrice = getCartTotalPriceElements();
      if ($totalPrice.length > 0) {
        $totalPrice.text(Shopify.formatMoney(cart.total_price, moneyFormat));
      }
      syncCartOriginalTotalDisplay(cart, moneyFormat);
    }
    // Ouvrir le contenu d'ajout rapide par défaut
    $('.cart-quick-add-toggle.active').each(function() {
      $(this).siblings('.cart-quick-add-content').show();
    });
    
    // S'assurer que le container de la progress bar est visible après le chargement
    const shippingBarContainer = $("[data-free-shipping-container]");
    if (cart.item_count > 0 && shippingBarContainer.length > 0) {
      shippingBarContainer.removeClass('hidden');
    }
    // Forcer la réinitialisation du flag pour permettre l'exécution
    isUpdatingTiers = false;
    lastCartPrice = 0;
    // Attendre un peu pour que le DOM soit complètement chargé
    setTimeout(function() {
      freeShippingBar(cart);
      updateTierGiftCartItemUi();
      // Attendre un peu pour que le DOM soit complètement chargé
      setTimeout(function() {
        if (typeof manageQuickAddProducts === 'function') {
          manageQuickAddProducts(cart);
        }
      }, 500);
    }, 200);
    upsellCartDrawerProducts(cart,'drawer')
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
      // $('[data-drawer-body]').find('a:first').trigger('focus');
    }
    if (animationStatus) {
      if (AOS) {
        AOS.refreshHard();
      }
    }
    if (!isCartMutationInProgress) {
  document.dispatchEvent(new CustomEvent('cart:updated'));
}
  }
  
  // Si le panier est vide, toujours recharger complètement le drawer pour afficher l'état vide
  if (cart.item_count === 0) {
    drawerBody.load(mainCartUrl + "?view=jsonData", function () {
      initializeCartAfterLoad(cart, showCart, element);
    });
    return;
  }
  
  // Si le container produits existe déjà (drawer déjà chargé), charger uniquement la partie produits
  if (productsContainer.length > 0 && drawerBody.length > 0) {
    // Utiliser la fonction globale updateCartProductsOnly qui met à jour produits + total
    if (typeof updateCartProductsOnly === 'function') {
      updateCartProductsOnly(cart);
    } else {
      // Fallback si la fonction n'est pas encore définie
      productsContainer.addClass("loading");
      $.ajax({
        url: mainCartUrl + "?view=jsonData",
        type: "GET",
        dataType: "html",
        success: function(result) {
          const $result = $(result);
          const newProductsContainer = $result.find("[data-cart-products-container]");
          const newBottomCartBox = $result.find(".bottom-cart-box");
          if (newProductsContainer.length > 0) {
            productsContainer.html(newProductsContainer.html());
          }
          const bottomCartBox = $(".bottom-cart-box");
          if (newBottomCartBox.length > 0 && bottomCartBox.length > 0) {
            bottomCartBox.html(newBottomCartBox.html());
          }
          productsContainer.removeClass("loading");
          initializeCartAfterLoad(cart, showCart, element);
        },
        error: function() {
          productsContainer.removeClass("loading");
          drawerBody.load(mainCartUrl + "?view=jsonData", function () {
            initializeCartAfterLoad(cart, showCart, element);
          });
        }
      });
      return; // Sortir ici pour ne pas continuer
    }
    // Si on doit ouvrir le drawer, l'ouvrir
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
    }
  } else {
    // Charger tout le drawer (premier chargement ou structure non disponible)
    drawerBody.load(mainCartUrl + "?view=jsonData", function () {
      initializeCartAfterLoad(cart, showCart, element);
    });
  }
};

$(document).on("click","[data-drawer-side-header]",function(){
  if($(this).closest(".yv-upsell-drawer").hasClass("active")){
    $(this).closest(".yv-upsell-drawer").removeClass("active")
  }else{
    $(this).closest(".yv-upsell-drawer").addClass("active")
  }
})
function upsellCartDrawerProducts(cart) {
  if (cart.item_count === 0) return;
  var upsellContainer = document.querySelector("[data-drawer-side-content]");
  if (!upsellContainer) return;
  var drawerEl = document.querySelector(".yv-upsell-drawer");
  if (!drawerEl) return;
  if (upsellContainer.closest("[x-data]")) {
    return;
  }
  var intent = upsellContainer.getAttribute("data-related-products");
  if (intent !== "product-list" && cart.items && cart.items.length > 0) {
    var apiIntent = (intent === "complementary") ? "complementary" : "related";
    var productId = cart.items[0].product_id;
    var limit = upsellContainer.getAttribute("data-limit") || "10";
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "") + "recommendations/products?product_id=" + productId + "&limit=" + limit + "&section_id=upsell-products&intent=" + apiIntent)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('#product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          upsellContainer.innerHTML = recommendations.innerHTML;
          drawerEl.classList.remove('hidden');
        } else {
          drawerEl.classList.add('hidden');
        }
      });
  } else {
    if (upsellContainer.children.length > 0) {
      drawerEl.classList.remove('hidden');
    } else {
      drawerEl.classList.add('hidden');
    }
  }
}
function upsellCartProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-cart-upsell-wrapper]")){
      let upsellWrapper=document.querySelector("[data-cart-upsell-wrapper]");
      // Ne pas toucher au bloc upsell dynamique (géré par Alpine cartCrossSell)
      if(upsellWrapper.hasAttribute("data-cart-page-dynamic-wrapper") || upsellWrapper.getAttribute("data-upsell-source") === "dynamic"){
        upsellWrapper.classList.remove('hidden');
        return;
      }
      let upsellContainer=upsellWrapper.querySelector("[data-cart-upsell]");
      let intent=upsellWrapper.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id;
        let limit=upsellWrapper.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
          .then(response => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              if(window.innerWidth >= 768 ){
                if(upsellContainer.classList.contains('flickity-enabled')){
                  let slider = Flickity.data(upsellContainer);
                  if(slider){
                    slider.destroy();
                    upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                  }
                }
                else{
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove('hidden')
                  flickitySlider(jQuery(upsellContainer));
                }
              }
              else{
                upsellContainer.innerHTML = recommendations.innerHTML;
                upsellWrapper.classList.remove('hidden')
              }
            }else{
              upsellWrapper.classList.add('hidden')
            }
          });
      }
      else{
        if(upsellContainer.classList.contains('flickity-enabled')){
          let slider = Flickity.data(upsellContainer);
          if(slider){
            slider.destroy();
          }
        }
        if(upsellContainer.children.length > 0){
          if(window.innerWidth >= 768 ){
            upsellWrapper.classList.remove('hidden')
            flickitySlider(jQuery(upsellContainer));
          }
          else{
            upsellWrapper.classList.remove('hidden')
          }
        }
        else{
          upsellWrapper.classList.add('hidden')
        }
      }
    }
  }
}

// Fonction pour charger les SVG uploadés et les convertir en inline avec currentColor
function loadSVGAsInline($img) {
  const svgUrl = $img.attr('data-svg-url') || $img.attr('src');
  if (!svgUrl) return;
  
  // Éviter de traiter deux fois
  if ($img.hasClass('svg-loading') || $img.hasClass('svg-loaded')) {
    return;
  }
  
  $img.addClass('svg-loading');
  
  fetch(svgUrl)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then(svgText => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = svgText;
      const svgElement = tempDiv.querySelector('svg');
      
      if (svgElement) {
        // Définir la couleur par défaut
        svgElement.style.color = 'inherit';
        
        // Remplacer stroke="black" et fill="black" par currentColor
        // Mais préserver fill="none" et stroke="none"
        svgElement.querySelectorAll('*').forEach(el => {
          if (el.hasAttribute('fill')) {
            const fill = el.getAttribute('fill');
            if (fill && fill !== 'none' && fill !== 'transparent' && fill !== 'currentColor') {
              el.setAttribute('fill', 'currentColor');
            }
          }
          if (el.hasAttribute('stroke')) {
            const stroke = el.getAttribute('stroke');
            if (stroke && stroke !== 'none' && stroke !== 'transparent' && stroke !== 'currentColor') {
              el.setAttribute('stroke', 'currentColor');
            }
          }
        });
        
        // Définir la taille
        svgElement.setAttribute('width', '24');
        svgElement.setAttribute('height', '24');
        svgElement.setAttribute('class', 'tier-icon-svg-inline');
        svgElement.style.width = '24px';
        svgElement.style.height = '24px';
        
        // Remplacer l'image par le SVG
        $img.replaceWith(svgElement);
      }
    })
    .catch(err => {
      $img.removeClass('svg-loading');
    });
}

// Charger les SVG au chargement de la page
$(document).ready(function() {
  $('.tier-icon-svg-load').each(function() {
    loadSVGAsInline($(this));
  });
});

// Observer les changements du DOM pour charger les nouveaux SVG
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    $('.tier-icon-svg-load:not(.svg-loading):not(.svg-loaded)').each(function() {
      loadSVGAsInline($(this));
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
